import * as $n from "vue";
import { defineComponent as Ne, h as zt, getCurrentScope as Yr, onScopeDispose as Gr, inject as qr, onMounted as ys, onUnmounted as Xr, Fragment as nt, computed as xt, watch as Po, ref as fe, shallowRef as zr, createVNode as wt, Text as Jr, reactive as vs, openBlock as G, createElementBlock as X, createElementVNode as f, toDisplayString as O, unref as k, createCommentVNode as Be, withDirectives as Ke, vModelText as ut, vModelDynamic as So, renderList as Ot, normalizeClass as Zr, createBlock as Qr, Teleport as ea, withModifiers as Es, resolveComponent as no, createTextVNode as Fe, withCtx as Jt } from "vue";
/*!
  * shared v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function Pe(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Do = {};
function ta(e) {
  Do[e] || (Do[e] = !0, Pe(e));
}
const We = typeof window < "u";
let be, rt;
if (process.env.NODE_ENV !== "production") {
  const e = We && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (be = (t) => {
    e.mark(t);
  }, rt = (t, n, o) => {
    e.measure(t, n, o), e.clearMarks(n), e.clearMarks(o);
  });
}
const na = /\{([0-9a-zA-Z]+)\}/g;
function fn(e, ...t) {
  return t.length === 1 && U(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(na, (n, o) => t.hasOwnProperty(o) ? t[o] : "");
}
const je = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), oa = (e, t, n) => sa({ l: e, k: t, s: n }), sa = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), le = (e) => typeof e == "number" && isFinite(e), ks = (e) => so(e) === "[object Date]", Zt = (e) => so(e) === "[object RegExp]", mn = (e) => K(e) && Object.keys(e).length === 0, re = Object.assign, ra = Object.create, q = (e = null) => ra(e);
let Mo;
const ot = () => Mo || (Mo = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : q());
function $o(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function aa(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
const ia = /^\s*javascript\s*(?::|&#0*58;?|&#x0*3a;?|&colon;?)/i, la = /^(?:href|src|action|formaction)$/i;
function oo(e) {
  return ia.test(e);
}
function ca(e) {
  const t = /url\s*\(/gi;
  let n = "", o = 0, s;
  for (; (s = t.exec(e)) !== null; ) {
    const r = s.index, a = t.lastIndex - 1;
    let i = a + 1, c = 1, d = null;
    for (; i < e.length; i++) {
      const h = e[i];
      if (d) {
        h === d && (d = null);
        continue;
      }
      if (h === '"' || h === "'")
        d = h;
      else if (h === "(")
        c++;
      else if (h === ")" && (c--, c === 0))
        break;
    }
    if (c !== 0)
      break;
    const _ = e.slice(a + 1, i).trim(), y = _.startsWith('"') && _.endsWith('"') || _.startsWith("'") && _.endsWith("'") ? _.slice(1, -1).trim() : _;
    n += e.slice(o, r), n += oo(y) ? "url(about:blank)" : e.slice(r, i + 1), o = i + 1;
  }
  return n + e.slice(o);
}
function Ro(e, t) {
  if (la.test(e) && oo(t))
    return "about:blank";
  const n = e.toLowerCase() === "style" ? ca(t) : t;
  return aa(n);
}
function ua(e) {
  return e = e.replace(/([\w:-]+)\s*=\s*"([^"]*)"/g, (n, o, s) => `${o}="${Ro(o, s)}"`), e = e.replace(/([\w:-]+)\s*=\s*'([^']*)'/g, (n, o, s) => `${o}='${Ro(o, s)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && Pe("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), e = e.replace(/(\s+(?:href|src|action|formaction)\s*=\s*)([^\s"'=<>`]+)/gi, (n, o, s) => oo(s) ? `${o}about:blank` : n), e;
}
const da = Object.prototype.hasOwnProperty;
function Ce(e, t) {
  return da.call(e, t);
}
const oe = Array.isArray, Z = (e) => typeof e == "function", I = (e) => typeof e == "string", ne = (e) => typeof e == "boolean", U = (e) => e !== null && typeof e == "object", fa = (e) => U(e) && Z(e.then) && Z(e.catch), Cs = Object.prototype.toString, so = (e) => Cs.call(e), K = (e) => so(e) === "[object Object]", ma = (e) => e == null ? "" : oe(e) || K(e) && e.toString === Cs ? JSON.stringify(e, null, 2) : String(e);
function ro(e, t = "") {
  return e.reduce((n, o, s) => s === 0 ? n + o : n + t + o, "");
}
const Fo = 2;
function pa(e, t = 0, n = e.length) {
  const o = e.split(/\r?\n/);
  let s = 0;
  const r = [];
  for (let a = 0; a < o.length; a++)
    if (s += o[a].length + 1, s >= t) {
      for (let i = a - Fo; i <= a + Fo || n > s; i++) {
        if (i < 0 || i >= o.length)
          continue;
        const c = i + 1;
        r.push(`${c}${" ".repeat(3 - String(c).length)}|  ${o[i]}`);
        const d = o[i].length;
        if (i === a) {
          const _ = t - (s - d) + 1, y = Math.max(1, n > s ? d - _ : n - t);
          r.push("   |  " + " ".repeat(_) + "^".repeat(y));
        } else if (i > a) {
          if (n > s) {
            const _ = Math.max(Math.min(n - s, d), 1);
            r.push("   |  " + "^".repeat(_));
          }
          s += d + 1;
        }
      }
      break;
    }
  return r.join(`
`);
}
function Ls() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, o) {
      const s = e.get(n);
      s && s.push(o) || e.set(n, [o]);
    },
    off(n, o) {
      const s = e.get(n);
      s && s.splice(s.indexOf(o) >>> 0, 1);
    },
    emit(n, o) {
      (e.get(n) || []).slice().map((s) => s(o)), (e.get("*") || []).slice().map((s) => s(n, o));
    }
  };
}
const Kt = (e) => !U(e) || oe(e);
function Xt(e, t) {
  if (Kt(e) || Kt(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: o, des: s } = n.pop();
    Object.keys(o).forEach((r) => {
      r !== "__proto__" && (U(o[r]) && !U(s[r]) && (s[r] = Array.isArray(o[r]) ? [] : q()), Kt(s[r]) || Kt(o[r]) ? s[r] = o[r] : n.push({ src: o[r], des: s[r] }));
    });
  }
}
/*!
  * message-compiler v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function wa(e, t, n) {
  return { line: e, column: t, offset: n };
}
function Wn(e, t, n) {
  return { start: e, end: t };
}
const $ = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, ha = 17, ga = {
  // tokenizer error messages
  [$.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [$.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [$.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [$.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [$.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [$.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [$.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [$.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [$.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [$.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [$.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [$.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [$.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [$.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [$.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [$.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function yt(e, t, n = {}) {
  const { domain: o, messages: s, args: r } = n, a = process.env.NODE_ENV !== "production" ? fn((s || ga)[e] || "", ...r || []) : e, i = new SyntaxError(String(a));
  return i.code = e, t && (i.location = t), i.domain = o, i;
}
function ba(e) {
  throw e;
}
const _a = /<\/?[\w\s="/.':;#-\/]+>/, ya = (e) => _a.test(e), Ae = " ", va = "\r", ue = `
`, Ea = "\u2028", ka = "\u2029";
function Ca(e) {
  const t = e;
  let n = 0, o = 1, s = 1, r = 0;
  const a = (v) => t[v] === va && t[v + 1] === ue, i = (v) => t[v] === ue, c = (v) => t[v] === ka, d = (v) => t[v] === Ea, _ = (v) => a(v) || i(v) || c(v) || d(v), y = () => n, h = () => o, N = () => s, D = () => r, P = (v) => a(v) || c(v) || d(v) ? ue : t[v], S = () => P(n), w = () => P(n + r);
  function g() {
    return r = 0, _(n) && (o++, s = 0), a(n) && n++, n++, s++, t[n];
  }
  function L() {
    return a(n + r) && r++, r++, t[n + r];
  }
  function b() {
    n = 0, o = 1, s = 1, r = 0;
  }
  function T(v = 0) {
    r = v;
  }
  function x() {
    const v = n + r;
    for (; v !== n; )
      g();
    r = 0;
  }
  return {
    index: y,
    line: h,
    column: N,
    peekOffset: D,
    charAt: P,
    currentChar: S,
    currentPeek: w,
    next: g,
    peek: L,
    reset: b,
    resetPeek: T,
    skipToPeek: x
  };
}
const Re = void 0, La = ".", Uo = "'", Ta = "tokenizer";
function Na(e, t = {}) {
  const n = t.location !== !1, o = Ca(e), s = () => o.index(), r = () => wa(o.line(), o.column(), o.index()), a = r(), i = s(), c = {
    currentType: 13,
    offset: i,
    startLoc: a,
    endLoc: a,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, d = () => c, { onError: _ } = t;
  function y(l, u, E, ...A) {
    const J = d();
    if (u.column += E, u.offset += E, _) {
      const ee = n ? Wn(J.startLoc, u) : null, B = yt(l, ee, {
        domain: Ta,
        args: A
      });
      _(B);
    }
  }
  function h(l, u, E) {
    l.endLoc = r(), l.currentType = u;
    const A = { type: u };
    return n && (A.loc = Wn(l.startLoc, l.endLoc)), E != null && (A.value = E), A;
  }
  const N = (l) => h(
    l,
    13
    /* TokenTypes.EOF */
  );
  function D(l, u) {
    return l.currentChar() === u ? (l.next(), u) : (y($.EXPECTED_TOKEN, r(), 0, u), "");
  }
  function P(l) {
    let u = "";
    for (; l.currentPeek() === Ae || l.currentPeek() === ue; )
      u += l.currentPeek(), l.peek();
    return u;
  }
  function S(l) {
    const u = P(l);
    return l.skipToPeek(), u;
  }
  function w(l) {
    if (l === Re)
      return !1;
    const u = l.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u === 95;
  }
  function g(l) {
    if (l === Re)
      return !1;
    const u = l.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function L(l, u) {
    const { currentType: E } = u;
    if (E !== 2)
      return !1;
    P(l);
    const A = w(l.currentPeek());
    return l.resetPeek(), A;
  }
  function b(l, u) {
    const { currentType: E } = u;
    if (E !== 2)
      return !1;
    P(l);
    const A = l.currentPeek() === "-" ? l.peek() : l.currentPeek(), J = g(A);
    return l.resetPeek(), J;
  }
  function T(l, u) {
    const { currentType: E } = u;
    if (E !== 2)
      return !1;
    P(l);
    const A = l.currentPeek() === Uo;
    return l.resetPeek(), A;
  }
  function x(l, u) {
    const { currentType: E } = u;
    if (E !== 7)
      return !1;
    P(l);
    const A = l.currentPeek() === ".";
    return l.resetPeek(), A;
  }
  function v(l, u) {
    const { currentType: E } = u;
    if (E !== 8)
      return !1;
    P(l);
    const A = w(l.currentPeek());
    return l.resetPeek(), A;
  }
  function F(l, u) {
    const { currentType: E } = u;
    if (!(E === 7 || E === 11))
      return !1;
    P(l);
    const A = l.currentPeek() === ":";
    return l.resetPeek(), A;
  }
  function R(l, u) {
    const { currentType: E } = u;
    if (E !== 9)
      return !1;
    const A = () => {
      const ee = l.currentPeek();
      return ee === "{" ? w(l.peek()) : ee === "@" || ee === "|" || ee === ":" || ee === "." || ee === Ae || !ee ? !1 : ee === ue ? (l.peek(), A()) : pe(l, !1);
    }, J = A();
    return l.resetPeek(), J;
  }
  function j(l) {
    P(l);
    const u = l.currentPeek() === "|";
    return l.resetPeek(), u;
  }
  function pe(l, u = !0) {
    const E = (J = !1, ee = "") => {
      const B = l.currentPeek();
      return B === "{" || B === "@" || !B ? J : B === "|" ? !(ee === Ae || ee === ue) : B === Ae ? (l.peek(), E(!0, Ae)) : B === ue ? (l.peek(), E(!0, ue)) : !0;
    }, A = E();
    return u && l.resetPeek(), A;
  }
  function z(l, u) {
    const E = l.currentChar();
    return E === Re ? Re : u(E) ? (l.next(), E) : null;
  }
  function Me(l) {
    const u = l.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36;
  }
  function vn(l) {
    return z(l, Me);
  }
  function En(l) {
    const u = l.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36 || // $
    u === 45;
  }
  function kn(l) {
    return z(l, En);
  }
  function Cn(l) {
    const u = l.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function Ln(l) {
    return z(l, Cn);
  }
  function Tn(l) {
    const u = l.charCodeAt(0);
    return u >= 48 && u <= 57 || // 0-9
    u >= 65 && u <= 70 || // A-F
    u >= 97 && u <= 102;
  }
  function $e(l) {
    return z(l, Tn);
  }
  function Lt(l) {
    let u = "", E = "";
    for (; u = Ln(l); )
      E += u;
    return E;
  }
  function Nn(l) {
    let u = "";
    for (; ; ) {
      const E = l.currentChar();
      if (E === "\\") {
        const A = l.peek();
        A === "{" || A === "}" || A === "@" || A === "|" || A === "\\" ? (u += E + A, l.next(), l.next()) : (l.resetPeek(), u += E, l.next());
      } else {
        if (E === "{" || E === "}" || E === "@" || E === "|" || !E)
          break;
        if (E === Ae || E === ue)
          if (pe(l))
            u += E, l.next();
          else {
            if (j(l))
              break;
            u += E, l.next();
          }
        else
          u += E, l.next();
      }
    }
    return u;
  }
  function An(l) {
    S(l);
    let u = "", E = "";
    for (; u = kn(l); )
      E += u;
    const A = l.currentChar();
    if (A && A !== "}" && A !== Re && A !== Ae && A !== ue && A !== "　") {
      const J = jt(l);
      return y($.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, E + J), E + J;
    }
    return l.currentChar() === Re && y($.UNTERMINATED_CLOSING_BRACE, r(), 0), E;
  }
  function xn(l) {
    S(l);
    let u = "";
    return l.currentChar() === "-" ? (l.next(), u += `-${Lt(l)}`) : u += Lt(l), l.currentChar() === Re && y($.UNTERMINATED_CLOSING_BRACE, r(), 0), u;
  }
  function In(l) {
    return l !== Uo && l !== ue;
  }
  function Io(l) {
    S(l), D(l, "'");
    let u = "", E = "";
    for (; u = z(l, In); )
      u === "\\" ? E += On(l) : E += u;
    const A = l.currentChar();
    return A === ue || A === Re ? (y($.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, r(), 0), A === ue && (l.next(), D(l, "'")), E) : (D(l, "'"), E);
  }
  function On(l) {
    const u = l.currentChar();
    switch (u) {
      case "\\":
      case "'":
        return l.next(), `\\${u}`;
      case "u":
        return Wt(l, u, 4);
      case "U":
        return Wt(l, u, 6);
      default:
        return y($.UNKNOWN_ESCAPE_SEQUENCE, r(), 0, u), "";
    }
  }
  function Wt(l, u, E) {
    D(l, u);
    let A = "";
    for (let J = 0; J < E; J++) {
      const ee = $e(l);
      if (!ee) {
        y($.INVALID_UNICODE_ESCAPE_SEQUENCE, r(), 0, `\\${u}${A}${l.currentChar()}`);
        break;
      }
      A += ee;
    }
    return `\\${u}${A}`;
  }
  function Pn(l) {
    return l !== "{" && l !== "}" && l !== Ae && l !== ue;
  }
  function jt(l) {
    S(l);
    let u = "", E = "";
    for (; u = z(l, Pn); )
      E += u;
    return E;
  }
  function Sn(l) {
    let u = "", E = "";
    for (; u = vn(l); )
      E += u;
    return E;
  }
  function Dn(l) {
    const u = (E) => {
      const A = l.currentChar();
      return A === "{" || A === "@" || A === "|" || A === "(" || A === ")" || !A || A === Ae ? E : (E += A, l.next(), u(E));
    };
    return u("");
  }
  function Tt(l) {
    S(l);
    const u = D(
      l,
      "|"
      /* TokenChars.Pipe */
    );
    return S(l), u;
  }
  function Nt(l, u) {
    let E = null;
    switch (l.currentChar()) {
      case "{":
        return u.braceNest >= 1 && y($.NOT_ALLOW_NEST_PLACEHOLDER, r(), 0), l.next(), E = h(
          u,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), S(l), u.braceNest++, E;
      case "}":
        return u.braceNest > 0 && u.currentType === 2 && y($.EMPTY_PLACEHOLDER, r(), 0), l.next(), E = h(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), u.braceNest--, u.braceNest > 0 && S(l), u.inLinked && u.braceNest === 0 && (u.inLinked = !1), E;
      case "@":
        return u.braceNest > 0 && y($.UNTERMINATED_CLOSING_BRACE, r(), 0), E = Je(l, u) || N(u), u.braceNest = 0, E;
      default: {
        let J = !0, ee = !0, B = !0;
        if (j(l))
          return u.braceNest > 0 && y($.UNTERMINATED_CLOSING_BRACE, r(), 0), E = h(u, 1, Tt(l)), u.braceNest = 0, u.inLinked = !1, E;
        if (u.braceNest > 0 && (u.currentType === 4 || u.currentType === 5 || u.currentType === 6))
          return y($.UNTERMINATED_CLOSING_BRACE, r(), 0), u.braceNest = 0, At(l, u);
        if (J = L(l, u))
          return E = h(u, 4, An(l)), S(l), E;
        if (ee = b(l, u))
          return E = h(u, 5, xn(l)), S(l), E;
        if (B = T(l, u))
          return E = h(u, 6, Io(l)), S(l), E;
        if (!J && !ee && !B)
          return E = h(u, 12, jt(l)), y($.INVALID_TOKEN_IN_PLACEHOLDER, r(), 0, E.value), S(l), E;
        break;
      }
    }
    return E;
  }
  function Je(l, u) {
    const { currentType: E } = u;
    let A = null;
    const J = l.currentChar();
    switch ((E === 7 || E === 8 || E === 11 || E === 9) && (J === ue || J === Ae) && y($.INVALID_LINKED_FORMAT, r(), 0), J) {
      case "@":
        return l.next(), A = h(
          u,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), u.inLinked = !0, A;
      case ".":
        return S(l), l.next(), h(
          u,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return S(l), l.next(), h(
          u,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return j(l) ? (A = h(u, 1, Tt(l)), u.braceNest = 0, u.inLinked = !1, A) : x(l, u) || F(l, u) ? (S(l), Je(l, u)) : v(l, u) ? (S(l), h(u, 11, Sn(l))) : R(l, u) ? (S(l), J === "{" ? Nt(l, u) || A : h(u, 10, Dn(l))) : (E === 7 && y($.INVALID_LINKED_FORMAT, r(), 0), u.braceNest = 0, u.inLinked = !1, At(l, u));
    }
  }
  function At(l, u) {
    let E = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (u.braceNest > 0)
      return Nt(l, u) || N(u);
    if (u.inLinked)
      return Je(l, u) || N(u);
    switch (l.currentChar()) {
      case "{":
        return Nt(l, u) || N(u);
      case "}":
        return y($.UNBALANCED_CLOSING_BRACE, r(), 0), l.next(), h(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Je(l, u) || N(u);
      default: {
        if (j(l))
          return E = h(u, 1, Tt(l)), u.braceNest = 0, u.inLinked = !1, E;
        if (pe(l))
          return h(u, 0, Nn(l));
        break;
      }
    }
    return E;
  }
  function Mn() {
    const { currentType: l, offset: u, startLoc: E, endLoc: A } = c;
    return c.lastType = l, c.lastOffset = u, c.lastStartLoc = E, c.lastEndLoc = A, c.offset = s(), c.startLoc = r(), o.currentChar() === Re ? h(
      c,
      13
      /* TokenTypes.EOF */
    ) : At(o, c);
  }
  return {
    nextToken: Mn,
    currentOffset: s,
    currentPosition: r,
    context: d
  };
}
const Aa = "parser", xa = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g, Ia = /\\([\\@{}|])/g;
function Oa(e, t) {
  return t;
}
function Pa(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const o = parseInt(t || n, 16);
      return o <= 55295 || o >= 57344 ? String.fromCodePoint(o) : "�";
    }
  }
}
function Sa(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function o(w, g, L, b, ...T) {
    const x = w.currentPosition();
    if (x.offset += b, x.column += b, n) {
      const v = t ? Wn(L, x) : null, F = yt(g, v, {
        domain: Aa,
        args: T
      });
      n(F);
    }
  }
  function s(w, g, L) {
    const b = { type: w };
    return t && (b.start = g, b.end = g, b.loc = { start: L, end: L }), b;
  }
  function r(w, g, L, b) {
    t && (w.end = g, w.loc && (w.loc.end = L));
  }
  function a(w, g) {
    const L = w.context(), b = s(3, L.offset, L.startLoc);
    return b.value = g.replace(Ia, Oa), r(b, w.currentOffset(), w.currentPosition()), b;
  }
  function i(w, g) {
    const L = w.context(), { lastOffset: b, lastStartLoc: T } = L, x = s(5, b, T);
    return x.index = parseInt(g, 10), w.nextToken(), r(x, w.currentOffset(), w.currentPosition()), x;
  }
  function c(w, g) {
    const L = w.context(), { lastOffset: b, lastStartLoc: T } = L, x = s(4, b, T);
    return x.key = g, w.nextToken(), r(x, w.currentOffset(), w.currentPosition()), x;
  }
  function d(w, g) {
    const L = w.context(), { lastOffset: b, lastStartLoc: T } = L, x = s(9, b, T);
    return x.value = g.replace(xa, Pa), w.nextToken(), r(x, w.currentOffset(), w.currentPosition()), x;
  }
  function _(w) {
    const g = w.nextToken(), L = w.context(), { lastOffset: b, lastStartLoc: T } = L, x = s(8, b, T);
    return g.type !== 11 ? (o(w, $.UNEXPECTED_EMPTY_LINKED_MODIFIER, L.lastStartLoc, 0), x.value = "", r(x, b, T), {
      nextConsumeToken: g,
      node: x
    }) : (g.value == null && o(w, $.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, xe(g)), x.value = g.value || "", r(x, w.currentOffset(), w.currentPosition()), {
      node: x
    });
  }
  function y(w, g) {
    const L = w.context(), b = s(7, L.offset, L.startLoc);
    return b.value = g, r(b, w.currentOffset(), w.currentPosition()), b;
  }
  function h(w) {
    const g = w.context(), L = s(6, g.offset, g.startLoc);
    let b = w.nextToken();
    if (b.type === 8) {
      const T = _(w);
      L.modifier = T.node, b = T.nextConsumeToken || w.nextToken();
    }
    switch (b.type !== 9 && o(w, $.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, xe(b)), b = w.nextToken(), b.type === 2 && (b = w.nextToken()), b.type) {
      case 10:
        b.value == null && o(w, $.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, xe(b)), L.key = y(w, b.value || "");
        break;
      case 4:
        b.value == null && o(w, $.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, xe(b)), L.key = c(w, b.value || "");
        break;
      case 5:
        b.value == null && o(w, $.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, xe(b)), L.key = i(w, b.value || "");
        break;
      case 6:
        b.value == null && o(w, $.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, xe(b)), L.key = d(w, b.value || "");
        break;
      default: {
        o(w, $.UNEXPECTED_EMPTY_LINKED_KEY, g.lastStartLoc, 0);
        const T = w.context(), x = s(7, T.offset, T.startLoc);
        return x.value = "", r(x, T.offset, T.startLoc), L.key = x, r(L, T.offset, T.startLoc), {
          nextConsumeToken: b,
          node: L
        };
      }
    }
    return r(L, w.currentOffset(), w.currentPosition()), {
      node: L
    };
  }
  function N(w) {
    const g = w.context(), L = g.currentType === 1 ? w.currentOffset() : g.offset, b = g.currentType === 1 ? g.endLoc : g.startLoc, T = s(2, L, b);
    T.items = [];
    let x = null;
    do {
      const R = x || w.nextToken();
      switch (x = null, R.type) {
        case 0:
          R.value == null && o(w, $.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, xe(R)), T.items.push(a(w, R.value || ""));
          break;
        case 5:
          R.value == null && o(w, $.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, xe(R)), T.items.push(i(w, R.value || ""));
          break;
        case 4:
          R.value == null && o(w, $.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, xe(R)), T.items.push(c(w, R.value || ""));
          break;
        case 6:
          R.value == null && o(w, $.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, xe(R)), T.items.push(d(w, R.value || ""));
          break;
        case 7: {
          const j = h(w);
          T.items.push(j.node), x = j.nextConsumeToken || null;
          break;
        }
      }
    } while (g.currentType !== 13 && g.currentType !== 1);
    const v = g.currentType === 1 ? g.lastOffset : w.currentOffset(), F = g.currentType === 1 ? g.lastEndLoc : w.currentPosition();
    return r(T, v, F), T;
  }
  function D(w, g, L, b) {
    const T = w.context();
    let x = b.items.length === 0;
    const v = s(1, g, L);
    v.cases = [], v.cases.push(b);
    do {
      const F = N(w);
      x || (x = F.items.length === 0), v.cases.push(F);
    } while (T.currentType !== 13);
    return x && o(w, $.MUST_HAVE_MESSAGES_IN_PLURAL, L, 0), r(v, w.currentOffset(), w.currentPosition()), v;
  }
  function P(w) {
    const g = w.context(), { offset: L, startLoc: b } = g, T = N(w);
    return g.currentType === 13 ? T : D(w, L, b, T);
  }
  function S(w) {
    const g = Na(w, re({}, e)), L = g.context(), b = s(0, L.offset, L.startLoc);
    return t && b.loc && (b.loc.source = w), b.body = P(g), e.onCacheKey && (b.cacheKey = e.onCacheKey(w)), L.currentType !== 13 && o(g, $.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, w[L.offset] || ""), r(b, g.currentOffset(), g.currentPosition()), b;
  }
  return { parse: S };
}
function xe(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Da(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (r) => (n.helpers.add(r), r) };
}
function Bo(e, t) {
  for (let n = 0; n < e.length; n++)
    ao(e[n], t);
}
function ao(e, t) {
  switch (e.type) {
    case 1:
      Bo(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Bo(e.items, t);
      break;
    case 6: {
      ao(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function Ma(e, t = {}) {
  const n = Da(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && ao(e.body, n);
  const o = n.context();
  e.helpers = Array.from(o.helpers);
}
function $a(e) {
  const t = e.body;
  return t.type === 2 ? Vo(t) : t.cases.forEach((n) => Vo(n)), e;
}
function Vo(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const o = e.items[n];
      if (!(o.type === 3 || o.type === 9) || o.value == null)
        break;
      t.push(o.value);
    }
    if (t.length === e.items.length) {
      e.static = ro(t);
      for (let n = 0; n < e.items.length; n++) {
        const o = e.items[n];
        (o.type === 3 || o.type === 9) && delete o.value;
      }
    }
  }
}
const Ra = "minifier";
function dt(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      dt(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let o = 0; o < n.length; o++)
        dt(n[o]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let o = 0; o < n.length; o++)
        dt(n[o]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      dt(t.key), t.k = t.key, delete t.key, t.modifier && (dt(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw yt($.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: Ra,
          args: [e.type]
        });
  }
  delete e.type;
}
const Fa = "parser";
function Ua(e, t) {
  const { filename: n, breakLineCode: o, needIndent: s } = t, r = t.location !== !1, a = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: s,
    indentLevel: 0
  };
  r && e.loc && (a.source = e.loc.source);
  const i = () => a;
  function c(P, S) {
    a.code += P;
  }
  function d(P, S = !0) {
    const w = S ? o : "";
    c(s ? w + "  ".repeat(P) : w);
  }
  function _(P = !0) {
    const S = ++a.indentLevel;
    P && d(S);
  }
  function y(P = !0) {
    const S = --a.indentLevel;
    P && d(S);
  }
  function h() {
    d(a.indentLevel);
  }
  return {
    context: i,
    push: c,
    indent: _,
    deindent: y,
    newline: h,
    helper: (P) => `_${P}`,
    needIndent: () => a.needIndent
  };
}
function Ba(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), ht(e, t.key), t.modifier ? (e.push(", "), ht(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Va(e, t) {
  const { helper: n, needIndent: o } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(o());
  const s = t.items.length;
  for (let r = 0; r < s && (ht(e, t.items[r]), r !== s - 1); r++)
    e.push(", ");
  e.deindent(o()), e.push("])");
}
function Ha(e, t) {
  const { helper: n, needIndent: o } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(o());
    const s = t.cases.length;
    for (let r = 0; r < s && (ht(e, t.cases[r]), r !== s - 1); r++)
      e.push(", ");
    e.deindent(o()), e.push("])");
  }
}
function Wa(e, t) {
  t.body ? ht(e, t.body) : e.push("null");
}
function ht(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      Wa(e, t);
      break;
    case 1:
      Ha(e, t);
      break;
    case 2:
      Va(e, t);
      break;
    case 6:
      Ba(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw yt($.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: Fa,
          args: [t.type]
        });
  }
}
const ja = (e, t = {}) => {
  const n = I(t.mode) ? t.mode : "normal", o = I(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const s = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, r = t.needIndent ? t.needIndent : n !== "arrow", a = e.helpers || [], i = Ua(e, {
    filename: o,
    breakLineCode: s,
    needIndent: r
  });
  i.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(r), a.length > 0 && (i.push(`const { ${ro(a.map((_) => `${_}: _${_}`), ", ")} } = ctx`), i.newline()), i.push("return "), ht(i, e), i.deindent(r), i.push("}"), delete e.helpers;
  const { code: c, map: d } = i.context();
  return {
    ast: e,
    code: c,
    map: d ? d.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Ka(e, t = {}) {
  const n = re({}, t), o = !!n.jit, s = !!n.minify, r = n.optimize == null ? !0 : n.optimize, i = Sa(n).parse(e);
  return o ? (r && $a(i), s && dt(i), { ast: i, code: "" }) : (Ma(i, n), ja(i, n));
}
/*!
  * core-base v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function Ya() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (ot().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (ot().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function Te(e) {
  return U(e) && io(e) === 0 && (Ce(e, "b") || Ce(e, "body"));
}
const Ts = ["b", "body"];
function Ga(e) {
  return Xe(e, Ts);
}
const Ns = ["c", "cases"];
function qa(e) {
  return Xe(e, Ns, []);
}
const As = ["s", "static"];
function Xa(e) {
  return Xe(e, As);
}
const xs = ["i", "items"];
function za(e) {
  return Xe(e, xs, []);
}
const Is = ["t", "type"];
function io(e) {
  return Xe(e, Is);
}
const Os = ["v", "value"];
function Yt(e, t) {
  const n = Xe(e, Os);
  if (n != null)
    return n;
  throw Pt(t);
}
const Ps = ["m", "modifier"];
function Ja(e) {
  return Xe(e, Ps);
}
const Ss = ["k", "key"];
function Za(e) {
  const t = Xe(e, Ss);
  if (t)
    return t;
  throw Pt(
    6
    /* NodeTypes.Linked */
  );
}
function Xe(e, t, n) {
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    if (Ce(e, s) && e[s] != null)
      return e[s];
  }
  return n;
}
const Ds = [
  ...Ts,
  ...Ns,
  ...As,
  ...xs,
  ...Ss,
  ...Ps,
  ...Os,
  ...Is
];
function Pt(e) {
  return new Error(`unhandled node type: ${e}`);
}
function Rn(e) {
  return (n) => Qa(n, e);
}
function Qa(e, t) {
  const n = Ga(t);
  if (n == null)
    throw Pt(
      0
      /* NodeTypes.Resource */
    );
  if (io(n) === 1) {
    const r = qa(n);
    return e.plural(r.reduce((a, i) => [
      ...a,
      Ho(e, i)
    ], []));
  } else
    return Ho(e, n);
}
function Ho(e, t) {
  const n = Xa(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const o = za(t).reduce((s, r) => [...s, jn(e, r)], []);
    return e.normalize(o);
  }
}
function jn(e, t) {
  const n = io(t);
  switch (n) {
    case 3:
      return Yt(t, n);
    case 9:
      return Yt(t, n);
    case 4: {
      const o = t;
      if (Ce(o, "k") && o.k)
        return e.interpolate(e.named(o.k));
      if (Ce(o, "key") && o.key)
        return e.interpolate(e.named(o.key));
      throw Pt(n);
    }
    case 5: {
      const o = t;
      if (Ce(o, "i") && le(o.i))
        return e.interpolate(e.list(o.i));
      if (Ce(o, "index") && le(o.index))
        return e.interpolate(e.list(o.index));
      throw Pt(n);
    }
    case 6: {
      const o = t, s = Ja(o), r = Za(o);
      return e.linked(jn(e, r), s ? jn(e, s) : void 0, e.type);
    }
    case 7:
      return Yt(t, n);
    case 8:
      return Yt(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const ei = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function ti(e, t) {
  t && ya(e) && Pe(fn(ei, { source: e }));
}
const ni = (e) => e;
let Gt = q();
function oi(e, t = {}) {
  let n = !1;
  const o = t.onError || ba;
  return t.onError = (s) => {
    n = !0, o(s);
  }, { ...Ka(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function si(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && I(e)) {
    const n = ne(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && ti(e, n);
    const s = (t.onCacheKey || ni)(e), r = Gt[s];
    if (r)
      return r;
    const { ast: a, detectError: i } = oi(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), c = Rn(a);
    return i ? c : Gt[s] = c;
  } else {
    if (process.env.NODE_ENV !== "production" && !Te(e))
      return Pe(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const o = Gt[n];
      return o || (Gt[n] = Rn(e));
    } else
      return Rn(e);
  }
}
let St = null;
function ri(e) {
  St = e;
}
function ai(e, t, n) {
  St && St.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const ii = /* @__PURE__ */ li("function:translate");
function li(e) {
  return (t) => St && St.emit(e, t);
}
const de = {
  INVALID_ARGUMENT: ha,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, ci = 24;
function Ue(e) {
  return yt(e, null, process.env.NODE_ENV !== "production" ? { messages: ui } : void 0);
}
const ui = {
  [de.INVALID_ARGUMENT]: "Invalid arguments",
  [de.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [de.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [de.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [de.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [de.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [de.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function lo(e, t) {
  return t.locale != null ? Wo(t.locale) : Wo(e.locale);
}
let Fn;
function Wo(e) {
  if (I(e))
    return e;
  if (Z(e)) {
    if (e.resolvedOnce && Fn != null)
      return Fn;
    if (e.constructor.name === "Function") {
      const t = e();
      if (fa(t))
        throw Ue(de.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Fn = t;
    } else
      throw Ue(de.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Ue(de.NOT_SUPPORT_LOCALE_TYPE);
}
function di(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...oe(t) ? t : U(t) ? Object.keys(t) : I(t) ? [t] : [n]
  ])];
}
function Kn(e, t, n) {
  const o = I(n) ? n : Qt, s = e;
  s.__localeChainCache || (s.__localeChainCache = /* @__PURE__ */ new Map());
  let r = s.__localeChainCache.get(o);
  if (!r) {
    r = [];
    let a = [n];
    for (; oe(a); )
      a = jo(r, a, t);
    const i = oe(t) || !K(t) ? t : t.default ? t.default : null;
    a = I(i) ? [i] : i, oe(a) && jo(r, a, !1), s.__localeChainCache.set(o, r);
  }
  return r;
}
function jo(e, t, n) {
  let o = !0;
  for (let s = 0; s < t.length && ne(o); s++) {
    const r = t[s];
    I(r) && (o = fi(e, t[s], n));
  }
  return o;
}
function fi(e, t, n) {
  let o;
  const s = t.split("-");
  do {
    const r = s.join("-");
    o = mi(e, r, n), s.splice(-1, 1);
  } while (s.length && o === !0);
  return o;
}
function mi(e, t, n) {
  let o = !1;
  if (!e.includes(t) && (o = !0, t)) {
    o = t[t.length - 1] !== "!";
    const s = t.replace(/!/g, "");
    e.push(s), (oe(n) || K(n)) && n[s] && (o = n[s]);
  }
  return o;
}
const ze = [];
ze[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ze[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ze[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
ze[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
ze[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
ze[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
ze[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const pi = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function wi(e) {
  return pi.test(e);
}
function hi(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function gi(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function bi(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : wi(t) ? hi(t) : "*" + t;
}
function _i(e) {
  const t = [];
  let n = -1, o = 0, s = 0, r, a, i, c, d, _, y;
  const h = [];
  h[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = i : a += i;
  }, h[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (t.push(a), a = void 0);
  }, h[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    h[
      0
      /* Actions.APPEND */
    ](), s++;
  }, h[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (s > 0)
      s--, o = 4, h[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (s = 0, a === void 0 || (a = bi(a), a === !1))
        return !1;
      h[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function N() {
    const D = e[n + 1];
    if (o === 5 && D === "'" || o === 6 && D === '"')
      return n++, i = "\\" + D, h[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (n++, r = e[n], !(r === "\\" && N())) {
      if (c = gi(r), y = ze[o], d = y[c] || y.l || 8, d === 8 || (o = d[0], d[1] !== void 0 && (_ = h[d[1]], _ && (i = r, _() === !1))))
        return;
      if (o === 7)
        return t;
    }
}
const Ko = /* @__PURE__ */ new Map();
function yi(e, t) {
  return U(e) ? e[t] : null;
}
function vi(e, t) {
  if (!U(e))
    return null;
  let n = Ko.get(t);
  if (n || (n = _i(t), n && Ko.set(t, n)), !n)
    return null;
  const o = n.length;
  let s = e, r = 0;
  for (; r < o; ) {
    const a = n[r];
    if (Ds.includes(a) && Te(s) || !U(s) || !Ce(s, a))
      return null;
    const i = s[a];
    if (i === void 0 || Z(s))
      return null;
    s = i, r++;
  }
  return s;
}
const ie = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  INVALID_NUMBER_ARGUMENT: 8,
  INVALID_DATE_ARGUMENT: 9
}, ct = 10, Ei = {
  [ie.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [ie.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [ie.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [ie.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [ie.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [ie.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [ie.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.",
  [ie.INVALID_NUMBER_ARGUMENT]: "Invalid argument for number formatting: expected a number but received '{value}'.",
  [ie.INVALID_DATE_ARGUMENT]: "Invalid argument for datetime formatting: expected a Date, number, or ISO string but received '{value}'."
};
function Ve(e, ...t) {
  return fn(Ei[e], ...t);
}
const ki = "11.4.4", pn = -1, Qt = "en-US", gt = "", Yo = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Ci() {
  return {
    upper: (e, t) => t === "text" && I(e) ? e.toUpperCase() : t === "vnode" && U(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && I(e) ? e.toLowerCase() : t === "vnode" && U(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && I(e) ? Yo(e) : t === "vnode" && U(e) && "__v_isVNode" in e ? Yo(e.children) : e
  };
}
let Ms;
function Li(e) {
  Ms = e;
}
let $s;
function Ti(e) {
  $s = e;
}
let Rs;
function Ni(e) {
  Rs = e;
}
let Fs = null;
const Ai = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  Fs = e;
}, xi = /* @__NO_SIDE_EFFECTS__ */ () => Fs;
let Us = null;
const Go = (e) => {
  Us = e;
}, Ii = () => Us;
let qo = 0;
function Oi(e = {}) {
  const t = Z(e.onWarn) ? e.onWarn : Pe, n = I(e.version) ? e.version : ki, o = I(e.locale) || Z(e.locale) ? e.locale : Qt, s = Z(o) ? Qt : o, r = oe(e.fallbackLocale) || K(e.fallbackLocale) || I(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : s, a = K(e.messages) ? e.messages : Un(s), i = K(e.datetimeFormats) ? e.datetimeFormats : Un(s), c = K(e.numberFormats) ? e.numberFormats : Un(s), d = re(q(), e.modifiers, Ci()), _ = e.pluralRules || q(), y = Z(e.missing) ? e.missing : null, h = ne(e.missingWarn) || Zt(e.missingWarn) ? e.missingWarn : !0, N = ne(e.fallbackWarn) || Zt(e.fallbackWarn) ? e.fallbackWarn : !0, D = !!e.fallbackFormat, P = !!e.unresolving, S = Z(e.postTranslation) ? e.postTranslation : null, w = K(e.processor) ? e.processor : null, g = ne(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, L = !!e.escapeParameter, b = Z(e.messageCompiler) ? e.messageCompiler : Ms;
  process.env.NODE_ENV !== "production" && Z(e.messageCompiler) && ta(Ve(ie.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const T = Z(e.messageResolver) ? e.messageResolver : $s || yi, x = Z(e.localeFallbacker) ? e.localeFallbacker : Rs || di, v = U(e.fallbackContext) ? e.fallbackContext : void 0, F = e, R = U(F.__datetimeFormatters) ? F.__datetimeFormatters : /* @__PURE__ */ new Map(), j = U(F.__numberFormatters) ? F.__numberFormatters : /* @__PURE__ */ new Map(), pe = U(F.__meta) ? F.__meta : {};
  qo++;
  const z = {
    version: n,
    cid: qo,
    locale: o,
    fallbackLocale: r,
    messages: a,
    modifiers: d,
    pluralRules: _,
    missing: y,
    missingWarn: h,
    fallbackWarn: N,
    fallbackFormat: D,
    unresolving: P,
    postTranslation: S,
    processor: w,
    warnHtmlMessage: g,
    escapeParameter: L,
    messageCompiler: b,
    messageResolver: T,
    localeFallbacker: x,
    fallbackContext: v,
    onWarn: t,
    __meta: pe
  };
  return z.datetimeFormats = i, z.numberFormats = c, z.__datetimeFormatters = R, z.__numberFormatters = j, process.env.NODE_ENV !== "production" && (z.__v_emitter = F.__v_emitter != null ? F.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && ai(z, n, pe), z;
}
const Un = (e) => ({ [e]: q() });
function wn(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function Bs(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function co(e, t, n, o, s) {
  const { missing: r, onWarn: a } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: s,
      groupId: `${s}:${t}`
    });
  }
  if (r !== null) {
    const i = r(e, n, t, s);
    return I(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && Bs(o, t) && a(Ve(ie.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function It(e, t, n) {
  const o = e;
  o.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function Vs(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function Pi(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let o = n + 1; o < t.length; o++)
    if (Vs(e, t[o]))
      return !0;
  return !1;
}
const Xo = typeof Intl < "u", Hs = {
  dateTimeFormat: Xo && typeof Intl.DateTimeFormat < "u",
  numberFormat: Xo && typeof Intl.NumberFormat < "u"
};
function zo(e, ...t) {
  const { datetimeFormats: n, unresolving: o, fallbackLocale: s, onWarn: r, localeFallbacker: a } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !Hs.dateTimeFormat)
    return r(Ve(ie.CANNOT_FORMAT_DATE)), gt;
  if (!I(t[0]) && !ks(t[0]) && !le(t[0]))
    return process.env.NODE_ENV !== "production" && r(Ve(ie.INVALID_DATE_ARGUMENT, {
      value: String(t[0])
    })), gt;
  const [c, d, _, y] = Yn(...t), h = ne(_.missingWarn) ? _.missingWarn : e.missingWarn, N = ne(_.fallbackWarn) ? _.fallbackWarn : e.fallbackWarn, D = !!_.part, P = lo(e, _), S = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    P
  );
  if (!I(c) || c === "")
    return new Intl.DateTimeFormat(P.replace(/!/g, ""), y).format(d);
  let w = {}, g, L = null, b = P, T = null;
  const x = "datetime format";
  for (let R = 0; R < S.length; R++) {
    if (g = T = S[R], process.env.NODE_ENV !== "production" && P !== g && wn(N, c) && r(Ve(ie.FALLBACK_TO_DATE_FORMAT, {
      key: c,
      target: g
    })), process.env.NODE_ENV !== "production" && P !== g) {
      const j = e.__v_emitter;
      j && j.emit("fallback", {
        type: x,
        key: c,
        from: b,
        to: T,
        groupId: `${x}:${c}`
      });
    }
    if (w = n[g] || {}, L = w[c], K(L))
      break;
    co(e, c, g, h, x), b = T;
  }
  if (!K(L) || !I(g))
    return o ? pn : c;
  let v = `${g}__${c}`;
  mn(y) || (v = `${v}__${JSON.stringify(y)}`);
  let F = i.get(v);
  return F || (F = new Intl.DateTimeFormat(g, re({}, L, y)), i.set(v, F)), D ? F.formatToParts(d) : F.format(d);
}
const Ws = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Yn(...e) {
  const [t, n, o, s] = e, r = q();
  let a = q(), i;
  if (I(t)) {
    const c = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!c)
      throw Ue(de.INVALID_ISO_DATE_ARGUMENT);
    const d = c[3] ? c[3].trim().startsWith("T") ? `${c[1].trim()}${c[3].trim()}` : `${c[1].trim()}T${c[3].trim()}` : c[1].trim();
    i = new Date(d);
    try {
      i.toISOString();
    } catch {
      throw Ue(de.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (ks(t)) {
    if (isNaN(t.getTime()))
      throw Ue(de.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (le(t))
    i = t;
  else
    throw Ue(de.INVALID_ARGUMENT);
  return I(n) ? r.key = n : K(n) && Object.keys(n).forEach((c) => {
    Ws.includes(c) ? a[c] = n[c] : r[c] = n[c];
  }), I(o) ? r.locale = o : K(o) && (a = o), K(s) && (a = s), [r.key || "", i, r, a];
}
function Jo(e, t, n) {
  const o = e;
  for (const s in n) {
    const r = `${t}__${s}`;
    o.__datetimeFormatters.has(r) && o.__datetimeFormatters.delete(r);
  }
}
function Zo(e, ...t) {
  const { numberFormats: n, unresolving: o, fallbackLocale: s, onWarn: r, localeFallbacker: a } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !Hs.numberFormat)
    return r(Ve(ie.CANNOT_FORMAT_NUMBER)), gt;
  if (!le(t[0]))
    return process.env.NODE_ENV !== "production" && r(Ve(ie.INVALID_NUMBER_ARGUMENT, {
      value: String(t[0])
    })), gt;
  const [c, d, _, y] = Gn(...t), h = ne(_.missingWarn) ? _.missingWarn : e.missingWarn, N = ne(_.fallbackWarn) ? _.fallbackWarn : e.fallbackWarn, D = !!_.part, P = lo(e, _), S = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    s,
    P
  );
  if (!I(c) || c === "")
    return new Intl.NumberFormat(P.replace(/!/g, ""), y).format(d);
  let w = {}, g, L = null, b = P, T = null;
  const x = "number format";
  for (let R = 0; R < S.length; R++) {
    if (g = T = S[R], process.env.NODE_ENV !== "production" && P !== g && wn(N, c) && r(Ve(ie.FALLBACK_TO_NUMBER_FORMAT, {
      key: c,
      target: g
    })), process.env.NODE_ENV !== "production" && P !== g) {
      const j = e.__v_emitter;
      j && j.emit("fallback", {
        type: x,
        key: c,
        from: b,
        to: T,
        groupId: `${x}:${c}`
      });
    }
    if (w = n[g] || {}, L = w[c], K(L))
      break;
    co(e, c, g, h, x), b = T;
  }
  if (!K(L) || !I(g))
    return o ? pn : c;
  let v = `${g}__${c}`;
  mn(y) || (v = `${v}__${JSON.stringify(y)}`);
  let F = i.get(v);
  return F || (F = new Intl.NumberFormat(g, re({}, L, y)), i.set(v, F)), D ? F.formatToParts(d) : F.format(d);
}
const js = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Gn(...e) {
  const [t, n, o, s] = e, r = q();
  let a = q();
  if (!le(t))
    throw Ue(de.INVALID_ARGUMENT);
  const i = t;
  return I(n) ? r.key = n : K(n) && Object.keys(n).forEach((c) => {
    js.includes(c) ? a[c] = n[c] : r[c] = n[c];
  }), I(o) ? r.locale = o : K(o) && (a = o), K(s) && (a = s), [r.key || "", i, r, a];
}
function Qo(e, t, n) {
  const o = e;
  for (const s in n) {
    const r = `${t}__${s}`;
    o.__numberFormatters.has(r) && o.__numberFormatters.delete(r);
  }
}
const Si = (e) => e, Di = (e) => "", Mi = "text", $i = (e) => e.length === 0 ? "" : ro(e), Ri = ma;
function Bn(e, t) {
  return e = Math.abs(e), t === 2 ? e === 1 ? 0 : 1 : Math.min(e, 2);
}
function Fi(e) {
  var n, o;
  const t = le(e.pluralIndex) ? e.pluralIndex : -1;
  return le((n = e.named) == null ? void 0 : n.count) ? e.named.count : le((o = e.named) == null ? void 0 : o.n) ? e.named.n : t;
}
function Ui(e = {}) {
  var w, g, L, b;
  const t = e.locale, n = Fi(e), o = I(t) && Z((w = e.pluralRules) == null ? void 0 : w[t]) ? e.pluralRules[t] : Bn, s = o === Bn ? void 0 : Bn, r = (T) => T[o(n, T.length, s)], a = e.list || [], i = (T) => a[T], c = e.named || q();
  le(e.pluralIndex) && (c.count || (c.count = e.pluralIndex), c.n || (c.n = e.pluralIndex));
  const d = (T) => c[T];
  function _(T, x) {
    const v = Z(e.messages) ? e.messages(T, !!x) : U(e.messages) ? e.messages[T] : !1;
    return v || (e.parent ? e.parent.message(T) : Di);
  }
  const y = (T) => e.modifiers ? e.modifiers[T] : Si, h = Z((g = e.processor) == null ? void 0 : g.normalize) ? e.processor.normalize : $i, N = Z((L = e.processor) == null ? void 0 : L.interpolate) ? e.processor.interpolate : Ri, D = I((b = e.processor) == null ? void 0 : b.type) ? e.processor.type : Mi, S = {
    list: i,
    named: d,
    plural: r,
    linked: (T, ...x) => {
      const [v, F] = x;
      let R = "text", j = "";
      x.length === 1 ? U(v) ? (j = v.modifier || j, R = v.type || R) : I(v) && (j = v || j) : x.length === 2 && (I(v) && (j = v || j), I(F) && (R = F || R));
      const pe = _(T, !0)(S), z = pe === "" || pe === void 0 ? T : pe, Me = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        R === "vnode" && oe(z) && j ? z[0] : z
      );
      return j ? y(j)(Me, R) : Me;
    },
    message: _,
    type: D,
    interpolate: N,
    normalize: h,
    values: re(q(), a, c)
  };
  return S;
}
const es = () => "", ke = (e) => Z(e);
function ts(e, ...t) {
  const { fallbackFormat: n, postTranslation: o, unresolving: s, messageCompiler: r, fallbackLocale: a, messages: i } = e, [c, d] = qn(...t), _ = ne(d.missingWarn) ? d.missingWarn : e.missingWarn, y = ne(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, h = ne(d.escapeParameter) ? d.escapeParameter : e.escapeParameter, N = !!d.resolvedMessage, D = I(d.default) || ne(d.default) ? ne(d.default) ? r ? c : () => c : d.default : n ? r ? c : () => c : null, P = n || D != null && (I(D) || Z(D)), S = lo(e, d);
  h && Bi(d);
  let [w, g, L] = N ? [
    c,
    S,
    i[S] || q()
  ] : Ks(e, c, S, a, y, _), b = w, T = c;
  if (!N && !(I(b) || Te(b) || ke(b)) && P && (b = D, T = b), !N && (!(I(b) || Te(b) || ke(b)) || !I(g)))
    return s ? pn : c;
  if (process.env.NODE_ENV !== "production" && I(b) && e.messageCompiler == null)
    return Pe(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${c}'.`), c;
  let x = !1;
  const v = () => {
    x = !0;
  }, F = ke(b) ? b : Ys(e, c, g, b, T, v);
  if (x)
    return b;
  const R = ji(e, g, L, d), j = Ui(R), pe = Vi(e, F, j);
  let z = o ? o(pe, c) : pe;
  if (h && I(z) && (z = ua(z)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const Me = {
      timestamp: Date.now(),
      key: I(c) ? c : ke(b) ? b.key : "",
      locale: g || (ke(b) ? b.locale : ""),
      format: I(b) ? b : ke(b) ? b.source : "",
      message: z
    };
    Me.meta = re({}, e.__meta, /* @__PURE__ */ xi() || {}), ii(Me);
  }
  return z;
}
function Bi(e) {
  oe(e.list) ? e.list = e.list.map((t) => I(t) ? $o(t) : t) : U(e.named) && Object.keys(e.named).forEach((t) => {
    I(e.named[t]) && (e.named[t] = $o(e.named[t]));
  });
}
function Ks(e, t, n, o, s, r) {
  const { messages: a, onWarn: i, messageResolver: c, localeFallbacker: d } = e, _ = d(e, o, n);
  let y = q(), h, N = null, D = n, P = null;
  const S = "translate";
  for (let w = 0; w < _.length; w++) {
    h = P = _[w], process.env.NODE_ENV !== "production" && n !== h && !Vs(n, h) && wn(s, t) && i(Ve(ie.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: h
    }));
    const g = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
    process.env.NODE_ENV !== "production" && n !== h && g && g.emit("fallback", {
      type: S,
      key: t,
      from: D,
      to: P,
      groupId: `${S}:${t}`
    }), y = a[h] || q();
    let L = null, b, T;
    if (process.env.NODE_ENV !== "production" && We && g && (L = window.performance.now(), b = "intlify-message-resolve-start", T = "intlify-message-resolve-end", be && be(b)), (N = c(y, t)) === null && (N = y[t]), process.env.NODE_ENV !== "production" && We && g) {
      const x = window.performance.now();
      g && L && N && g.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: N,
        time: x - L,
        groupId: `${S}:${t}`
      }), b && T && be && rt && (be(T), rt("intlify message resolve", b, T));
    }
    if (I(N) || Te(N) || ke(N))
      break;
    if (!Pi(h, _)) {
      const x = co(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        h,
        r,
        S
      );
      x !== t && (N = x);
    }
    D = P;
  }
  return [N, h, y];
}
function Ys(e, t, n, o, s, r) {
  const { messageCompiler: a, warnHtmlMessage: i } = e;
  if (ke(o)) {
    const N = o;
    return N.locale = N.locale || n, N.key = N.key || t, N;
  }
  if (a == null) {
    const N = () => o;
    return N.locale = n, N.key = t, N;
  }
  const c = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let d = null, _, y;
  process.env.NODE_ENV !== "production" && We && c && (d = window.performance.now(), _ = "intlify-message-compilation-start", y = "intlify-message-compilation-end", be && be(_));
  const h = a(o, Hi(e, n, s, o, i, r));
  if (process.env.NODE_ENV !== "production" && We && c) {
    const N = window.performance.now();
    c && d && c.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: N - d,
      groupId: `translate:${t}`
    }), _ && y && be && rt && (be(y), rt("intlify message compilation", _, y));
  }
  return h.locale = n, h.key = t, h.source = o, h;
}
function Vi(e, t, n) {
  const o = process.env.NODE_ENV !== "production" ? e.__v_emitter : void 0;
  let s = null, r, a;
  process.env.NODE_ENV !== "production" && We && o && (s = window.performance.now(), r = "intlify-message-evaluation-start", a = "intlify-message-evaluation-end", be && be(r));
  const i = t(n);
  if (process.env.NODE_ENV !== "production" && We && o) {
    const c = window.performance.now();
    o && s && o.emit("message-evaluation", {
      type: "message-evaluation",
      value: i,
      time: c - s,
      groupId: `translate:${t.key}`
    }), r && a && be && rt && (be(a), rt("intlify message evaluation", r, a));
  }
  return i;
}
function qn(...e) {
  const [t, n, o] = e, s = q();
  if (!I(t) && !le(t) && !ke(t) && !Te(t))
    throw Ue(de.INVALID_ARGUMENT);
  const r = le(t) ? String(t) : (ke(t), t);
  return le(n) ? s.plural = n : I(n) ? s.default = n : K(n) && !mn(n) ? s.named = n : oe(n) && (s.list = n), le(o) ? s.plural = o : I(o) ? s.default = o : K(o) && re(s, o), [r, s];
}
function Hi(e, t, n, o, s, r) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: s,
    onError: (a) => {
      if (r && r(a), process.env.NODE_ENV !== "production") {
        const i = Wi(o), c = a.location && i && pa(i, a.location.start.offset, a.location.end.offset), d = e.__v_emitter;
        d && i && d.emit("compile-error", {
          message: i,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${n}`
        });
        const _ = `Message compilation error: ${a.message}`;
        throw new SyntaxError(c ? `${_}
${c}` : _);
      }
      throw a;
    },
    onCacheKey: (a) => oa(t, n, a)
  };
}
function Wi(e) {
  if (I(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function ji(e, t, n, o) {
  const { modifiers: s, pluralRules: r, messageResolver: a, fallbackLocale: i, fallbackWarn: c, missingWarn: d, fallbackContext: _ } = e, h = {
    locale: t,
    modifiers: s,
    pluralRules: r,
    messages: (N, D) => {
      let P = a(n, N);
      if (P == null && (_ || D)) {
        const [S, , w] = Ks(
          _ || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          N,
          t,
          i,
          c,
          d
        );
        P = S ?? a(w, N);
      }
      if (I(P) || Te(P)) {
        let S = !1;
        const g = Ys(e, N, t, P, N, () => {
          S = !0;
        });
        return S ? es : g;
      } else return ke(P) ? P : es;
    }
  };
  return e.processor && (h.processor = e.processor), o.list && (h.list = o.list), o.named && (h.named = o.named), le(o.plural) && (h.pluralIndex = o.plural), h;
}
Ya();
/*!
  * vue-i18n v11.4.4
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
const Ki = "11.4.4";
function Yi() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (ot().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (ot().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (ot().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (ot().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const ae = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: ci,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function mt(e, ...t) {
  return yt(e, null, process.env.NODE_ENV !== "production" ? { messages: Gi, args: t } : void 0);
}
const Gi = {
  [ae.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [ae.INVALID_ARGUMENT]: "Invalid argument",
  [ae.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [ae.NOT_INSTALLED]: "Need to install with `app.use` function",
  [ae.UNEXPECTED_ERROR]: "Unexpected error",
  [ae.REQUIRED_VALUE]: "Required in value: {0}",
  [ae.INVALID_VALUE]: "Invalid value",
  [ae.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [ae.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [ae.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [ae.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Xn = /* @__PURE__ */ je("__translateVNode"), zn = /* @__PURE__ */ je("__datetimeParts"), Jn = /* @__PURE__ */ je("__numberParts"), Dt = /* @__PURE__ */ je("__enableEmitter"), Mt = /* @__PURE__ */ je("__disableEmitter"), qi = je("__setPluralRules"), Gs = /* @__PURE__ */ je("__injectWithOption"), ft = /* @__PURE__ */ je("__dispose"), Oe = {
  FALLBACK_TO_ROOT: ct,
  // 10
  NOT_FOUND_PARENT_SCOPE: ct + 1,
  IGNORE_OBJ_FLATTEN: ct + 2,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: ct + 3,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: ct + 4,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: ct + 5
}, Xi = {
  [Oe.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Oe.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Oe.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Oe.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [Oe.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [Oe.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function en(e, ...t) {
  return fn(Xi[e], ...t);
}
function $t(e) {
  if (!U(e) || Te(e))
    return e;
  for (const t in e)
    if (Ce(e, t))
      if (!t.includes("."))
        U(e[t]) && $t(e[t]);
      else {
        const n = t.split("."), o = n.length - 1;
        let s = e, r = !1;
        for (let a = 0; a < o; a++) {
          if (n[a] === "__proto__")
            throw new Error(`unsafe key: ${n[a]}`);
          if (n[a] in s || (s[n[a]] = q()), !U(s[n[a]])) {
            process.env.NODE_ENV !== "production" && Pe(en(Oe.IGNORE_OBJ_FLATTEN, {
              key: n[a]
            })), r = !0;
            break;
          }
          s = s[n[a]];
        }
        if (r || (Te(s) ? Ds.includes(n[o]) || delete e[t] : (s[n[o]] = e[t], delete e[t])), !Te(s)) {
          const a = s[n[o]];
          U(a) && $t(a);
        }
      }
  return e;
}
function qs(e, t) {
  const { messages: n, __i18n: o, messageResolver: s, flatJson: r } = t, a = K(n) ? n : oe(o) ? q() : { [e]: q() };
  if (oe(o) && o.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: c, resource: d } = i;
      c ? (a[c] = a[c] || q(), Xt(d, a[c])) : Xt(d, a);
    } else
      I(i) && Xt(JSON.parse(i), a);
  }), s == null && r)
    for (const i in a)
      Ce(a, i) && $t(a[i]);
  return a;
}
function Xs(e) {
  return e.type;
}
function zi(e, t, n) {
  let o = U(t.messages) ? t.messages : q();
  "__i18nGlobal" in n && (o = qs(e.locale.value, {
    messages: o,
    __i18n: n.__i18nGlobal
  }));
  const s = Object.keys(o);
  s.length && s.forEach((r) => {
    e.mergeLocaleMessage(r, o[r]);
  });
  {
    if (U(t.datetimeFormats)) {
      const r = Object.keys(t.datetimeFormats);
      r.length && r.forEach((a) => {
        e.mergeDateTimeFormat(a, t.datetimeFormats[a]);
      });
    }
    if (U(t.numberFormats)) {
      const r = Object.keys(t.numberFormats);
      r.length && r.forEach((a) => {
        e.mergeNumberFormat(a, t.numberFormats[a]);
      });
    }
  }
}
function ns(e) {
  return wt(Jr, null, e, 0);
}
function uo() {
  const e = "currentInstance";
  return e in $n ? $n[e] : $n.getCurrentInstance();
}
const os = "__INTLIFY_META__", ss = () => [], Ji = () => !1;
let rs = 0;
function as(e) {
  return (t, n, o, s) => e(n, o, uo() || void 0, s);
}
const Zi = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = uo();
  let t = null;
  return e && (t = Xs(e)[os]) ? { [os]: t } : null;
};
function is(e = {}) {
  const { __root: t, __injectWithOption: n } = e, o = t === void 0, s = e.flatJson, r = We ? fe : zr;
  let a = ne(e.inheritLocale) ? e.inheritLocale : !0;
  const i = r(
    // prettier-ignore
    t && a ? t.locale.value : I(e.locale) ? e.locale : Qt
  ), c = r(
    // prettier-ignore
    t && a ? t.fallbackLocale.value : I(e.fallbackLocale) || oe(e.fallbackLocale) || K(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), d = r(qs(i.value, e)), _ = r(K(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), y = r(K(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let h = t ? t.missingWarn : ne(e.missingWarn) || Zt(e.missingWarn) ? e.missingWarn : !0, N = t ? t.fallbackWarn : ne(e.fallbackWarn) || Zt(e.fallbackWarn) ? e.fallbackWarn : !0, D = t ? t.fallbackRoot : ne(e.fallbackRoot) ? e.fallbackRoot : !0, P = !!e.fallbackFormat, S = Z(e.missing) ? e.missing : null, w = Z(e.missing) ? as(e.missing) : null, g = Z(e.postTranslation) ? e.postTranslation : null, L = t ? t.warnHtmlMessage : ne(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, b = !!e.escapeParameter;
  const T = t ? t.modifiers : K(e.modifiers) ? e.modifiers : {};
  let x = e.pluralRules || t && t.pluralRules, v;
  v = (() => {
    o && Go(null);
    const p = {
      version: Ki,
      locale: i.value,
      fallbackLocale: c.value,
      messages: d.value,
      modifiers: T,
      pluralRules: x,
      missing: w === null ? void 0 : w,
      missingWarn: h,
      fallbackWarn: N,
      fallbackFormat: P,
      unresolving: !0,
      postTranslation: g === null ? void 0 : g,
      warnHtmlMessage: L,
      escapeParameter: b,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    p.datetimeFormats = _.value, p.numberFormats = y.value, p.__datetimeFormatters = K(v) ? v.__datetimeFormatters : void 0, p.__numberFormatters = K(v) ? v.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (p.__v_emitter = K(v) ? v.__v_emitter : void 0);
    const C = Oi(p);
    return o && Go(C), C;
  })(), It(v, i.value, c.value);
  function R() {
    return [
      i.value,
      c.value,
      d.value,
      _.value,
      y.value
    ];
  }
  const j = xt({
    get: () => i.value,
    set: (p) => {
      v.locale = p, i.value = p;
    }
  }), pe = xt({
    get: () => c.value,
    set: (p) => {
      v.fallbackLocale = p, c.value = p, It(v, i.value, p);
    }
  }), z = xt(() => d.value), Me = /* @__PURE__ */ xt(() => _.value), vn = /* @__PURE__ */ xt(() => y.value);
  function En() {
    return Z(g) ? g : null;
  }
  function kn(p) {
    g = p, v.postTranslation = p;
  }
  function Cn() {
    return S;
  }
  function Ln(p) {
    p !== null && (w = as(p)), S = p, v.missing = w;
  }
  function Tn(p, C) {
    return p !== "translate" || !C.resolvedMessage;
  }
  const $e = (p, C, V, Q, Ze, Qe) => {
    R();
    let Ee;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (v.fallbackContext = t ? Ii() : void 0), Ee = p(v);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (v.fallbackContext = void 0);
    }
    if (V !== "translate exists" && // for not `te` (e.g `t`)
    le(Ee) && Ee === pn || V === "translate exists" && !Ee) {
      const [et, Kr] = C();
      if (process.env.NODE_ENV !== "production" && t && I(et) && Tn(V, Kr) && (D && (wn(N, et) || Bs(h, et)) && Pe(en(Oe.FALLBACK_TO_ROOT, {
        key: et,
        type: V
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Oo } = v;
        Oo && D && Oo.emit("fallback", {
          type: V,
          key: et,
          to: "global",
          groupId: `${V}:${et}`
        });
      }
      return t && D ? Q(t) : Ze(et);
    } else {
      if (Qe(Ee))
        return Ee;
      throw mt(ae.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Lt(...p) {
    return $e((C) => Reflect.apply(ts, null, [C, ...p]), () => qn(...p), "translate", (C) => Reflect.apply(C.t, C, [...p]), (C) => C, (C) => I(C));
  }
  function Nn(...p) {
    const [C, V, Q] = p;
    if (Q && !U(Q))
      throw mt(ae.INVALID_ARGUMENT);
    return Lt(C, V, re({ resolvedMessage: !0 }, Q || {}));
  }
  function An(...p) {
    return $e((C) => Reflect.apply(zo, null, [C, ...p]), () => Yn(...p), "datetime format", (C) => Reflect.apply(C.d, C, [...p]), () => gt, (C) => I(C) || oe(C));
  }
  function xn(...p) {
    return $e((C) => Reflect.apply(Zo, null, [C, ...p]), () => Gn(...p), "number format", (C) => Reflect.apply(C.n, C, [...p]), () => gt, (C) => I(C) || oe(C));
  }
  function In(p) {
    return p.map((C) => I(C) || le(C) || ne(C) ? ns(String(C)) : C);
  }
  const On = {
    normalize: In,
    interpolate: (p) => p,
    type: "vnode"
  };
  function Wt(...p) {
    return $e((C) => {
      let V;
      const Q = C;
      try {
        Q.processor = On, V = Reflect.apply(ts, null, [Q, ...p]);
      } finally {
        Q.processor = null;
      }
      return V;
    }, () => qn(...p), "translate", (C) => C[Xn](...p), (C) => [ns(C)], (C) => oe(C));
  }
  function Pn(...p) {
    return $e((C) => Reflect.apply(Zo, null, [C, ...p]), () => Gn(...p), "number format", (C) => C[Jn](...p), ss, (C) => I(C) || oe(C));
  }
  function jt(...p) {
    return $e((C) => Reflect.apply(zo, null, [C, ...p]), () => Yn(...p), "datetime format", (C) => C[zn](...p), ss, (C) => I(C) || oe(C));
  }
  function Sn(p) {
    x = p, v.pluralRules = x;
  }
  function Dn(p, C) {
    return $e(() => {
      if (!p)
        return !1;
      const V = I(C) ? C : i.value, Q = I(C) ? [V] : Kn(v, c.value, V);
      for (let Ze = 0; Ze < Q.length; Ze++) {
        const Qe = Je(Q[Ze]);
        let Ee = v.messageResolver(Qe, p);
        if (Ee === null && (Ee = Qe[p]), Te(Ee) || ke(Ee) || I(Ee))
          return !0;
      }
      return !1;
    }, () => [p], "translate exists", (V) => Reflect.apply(V.te, V, [p, C]), Ji, (V) => ne(V));
  }
  function Tt(p) {
    let C = null;
    const V = Kn(v, c.value, i.value);
    for (let Q = 0; Q < V.length; Q++) {
      const Ze = d.value[V[Q]] || {}, Qe = v.messageResolver(Ze, p);
      if (Qe != null) {
        C = Qe;
        break;
      }
    }
    return C;
  }
  function Nt(p) {
    const C = Tt(p);
    return C ?? (t ? t.tm(p) || {} : {});
  }
  function Je(p) {
    return d.value[p] || {};
  }
  function At(p, C) {
    if (s) {
      const V = { [p]: C };
      for (const Q in V)
        Ce(V, Q) && $t(V[Q]);
      C = V[p];
    }
    d.value[p] = C, v.messages = d.value;
  }
  function Mn(p, C) {
    d.value[p] = d.value[p] || {};
    const V = { [p]: C };
    if (s)
      for (const Q in V)
        Ce(V, Q) && $t(V[Q]);
    C = V[p], Xt(C, d.value[p]), v.messages = d.value;
  }
  function l(p) {
    return _.value[p] || {};
  }
  function u(p, C) {
    _.value[p] = C, v.datetimeFormats = _.value, Jo(v, p, C);
  }
  function E(p, C) {
    _.value[p] = re(_.value[p] || {}, C), v.datetimeFormats = _.value, Jo(v, p, C);
  }
  function A(p) {
    return y.value[p] || {};
  }
  function J(p, C) {
    y.value[p] = C, v.numberFormats = y.value, Qo(v, p, C);
  }
  function ee(p, C) {
    y.value[p] = re(y.value[p] || {}, C), v.numberFormats = y.value, Qo(v, p, C);
  }
  rs++, t && We && (Po(t.locale, (p) => {
    a && (i.value = p, v.locale = p, It(v, i.value, c.value));
  }), Po(t.fallbackLocale, (p) => {
    a && (c.value = p, v.fallbackLocale = p, It(v, i.value, c.value));
  }));
  const B = {
    id: rs,
    locale: j,
    fallbackLocale: pe,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(p) {
      a = p, p && t && (i.value = t.locale.value, c.value = t.fallbackLocale.value, It(v, i.value, c.value));
    },
    get availableLocales() {
      return Object.keys(d.value).sort();
    },
    messages: z,
    get modifiers() {
      return T;
    },
    get pluralRules() {
      return x || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return h;
    },
    set missingWarn(p) {
      h = p, v.missingWarn = h;
    },
    get fallbackWarn() {
      return N;
    },
    set fallbackWarn(p) {
      N = p, v.fallbackWarn = N;
    },
    get fallbackRoot() {
      return D;
    },
    set fallbackRoot(p) {
      D = p;
    },
    get fallbackFormat() {
      return P;
    },
    set fallbackFormat(p) {
      P = p, v.fallbackFormat = P;
    },
    get warnHtmlMessage() {
      return L;
    },
    set warnHtmlMessage(p) {
      L = p, v.warnHtmlMessage = p;
    },
    get escapeParameter() {
      return b;
    },
    set escapeParameter(p) {
      b = p, v.escapeParameter = p;
    },
    t: Lt,
    getLocaleMessage: Je,
    setLocaleMessage: At,
    mergeLocaleMessage: Mn,
    getPostTranslationHandler: En,
    setPostTranslationHandler: kn,
    getMissingHandler: Cn,
    setMissingHandler: Ln,
    [qi]: Sn
  };
  return B.datetimeFormats = Me, B.numberFormats = vn, B.rt = Nn, B.te = Dn, B.tm = Nt, B.d = An, B.n = xn, B.getDateTimeFormat = l, B.setDateTimeFormat = u, B.mergeDateTimeFormat = E, B.getNumberFormat = A, B.setNumberFormat = J, B.mergeNumberFormat = ee, B[Gs] = n, B[Xn] = Wt, B[zn] = jt, B[Jn] = Pn, process.env.NODE_ENV !== "production" && (B[Dt] = (p) => {
    v.__v_emitter = p;
  }, B[Mt] = () => {
    v.__v_emitter = void 0;
  }), B;
}
function tn(e, t) {
}
const fo = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Qi({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((o, s) => [
    ...o,
    // prettier-ignore
    ...s.type === nt ? s.children : [s]
  ], []) : t.reduce((n, o) => {
    const s = e[o];
    return s && (n[o] = s()), n;
  }, q());
}
function zs() {
  return nt;
}
re({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => le(e) || !isNaN(e)
  }
}, fo);
function el(e) {
  return oe(e) && !I(e[0]);
}
function Js(e, t, n, o) {
  const { slots: s, attrs: r } = t;
  return () => {
    const a = () => {
      const d = { part: !0 };
      let _ = q();
      e.locale && (d.locale = e.locale), I(e.format) ? d.key = e.format : U(e.format) && (I(e.format.key) && (d.key = e.format.key), _ = Object.keys(e.format).reduce((N, D) => n.includes(D) ? re(q(), N, { [D]: e.format[D] }) : N, q()));
      const y = o(e.value, d, _);
      let h = [d.key];
      return oe(y) ? h = y.map((N, D) => {
        const P = s[N.type], S = P ? P({ [N.type]: N.value, index: D, parts: y }) : [N.value];
        return el(S) && (S[0].key = `${N.type}-${D}`), S;
      }) : I(y) && (h = [y]), h;
    }, i = re(q(), r), c = I(e.tag) || U(e.tag) ? e.tag : zs();
    return U(c) ? zt(c, i, { default: a }) : zt(c, i, a());
  };
}
re({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, fo);
const tl = /* @__PURE__ */ je("global-vue-i18n");
function De(e = {}) {
  const t = uo();
  if (t == null)
    throw mt(ae.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw mt(ae.NOT_INSTALLED);
  const n = nl(t), o = sl(n), s = Xs(t), r = ol(e, s);
  if (r === "global")
    return zi(o, e, s), o;
  if (r === "parent") {
    let c = ls(n, t, e.__useComponent);
    return c == null && (process.env.NODE_ENV !== "production" && Pe(en(Oe.NOT_FOUND_PARENT_SCOPE)), c = o), c;
  }
  if (r === "isolated") {
    if (n.mode !== "composition")
      throw mt(ae.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const c = n, d = re({}, e), _ = ls(n, t);
    d.__root = _ || o;
    const y = is(d);
    c.__composerExtend && (y[ft] = c.__composerExtend(y));
    let h = null;
    if (process.env.NODE_ENV !== "production") {
      h = Ls();
      const D = y;
      D[Dt] && D[Dt](h), h.on("*", tn);
    }
    return Yr() && Gr(() => {
      if (process.env.NODE_ENV !== "production") {
        h && h.off("*", tn);
        const P = y;
        P[Mt] && P[Mt]();
      }
      const D = y[ft];
      D && (D(), delete y[ft]);
    }), y;
  }
  const a = n;
  let i = a.__getInstance(t);
  if (i == null) {
    const c = re({}, e);
    "__i18n" in s && (c.__i18n = s.__i18n), o && (c.__root = o), i = is(c), a.__composerExtend && (i[ft] = a.__composerExtend(i)), al(a, t, i), a.__setInstance(t, i);
  } else
    process.env.NODE_ENV !== "production" && r === "local" && Pe(en(Oe.DUPLICATE_USE_I18N_CALLING));
  return i;
}
function nl(e) {
  const t = qr(e.isCE ? tl : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw mt(e.isCE ? ae.NOT_INSTALLED_WITH_PROVIDE : ae.UNEXPECTED_ERROR);
  return t;
}
function ol(e, t) {
  return mn(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function sl(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function ls(e, t, n = !1) {
  let o = null;
  const s = t.root;
  let r = rl(t, n);
  for (; r != null; ) {
    const a = e;
    if (e.mode === "composition")
      o = a.__getInstance(r);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = a.__getInstance(r);
      i != null && (o = i.__composer, n && o && !o[Gs] && (o = null));
    }
    if (o != null || s === r)
      break;
    r = r.parent;
  }
  return o;
}
function rl(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function al(e, t, n) {
  let o = null;
  ys(() => {
    if (process.env.NODE_ENV !== "production") {
      t.__VUE_I18N__ = n, o = Ls();
      const s = n;
      s[Dt] && s[Dt](o), o.on("*", tn);
    }
  }, t), Xr(() => {
    const s = n;
    process.env.NODE_ENV !== "production" && (o && o.off("*", tn), s[Mt] && s[Mt](), delete t.__VUE_I18N__), e.__deleteInstance(t);
    const r = s[ft];
    r && (r(), delete s[ft]);
  }, t);
}
re({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, fo);
Yi();
Li(si);
Ti(vi);
Ni(Kn);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = ot();
  e.__INTLIFY__ = !0, ri(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function il(e) {
  const t = fe(!1), n = fe(null), o = fe(!1), s = vs({
    account: "",
    password: "",
    password_old: ""
  });
  return { passwordForm: s, isUpdating: t, updateError: n, updateSuccess: o, submitPasswordChange: async () => {
    t.value = !0, n.value = null, o.value = !1;
    try {
      const a = await e.changePassword({ ...s });
      return o.value = !0, s.password = "", s.password_old = "", a;
    } catch {
      n.value = "變更密碼失敗";
    } finally {
      t.value = !1;
    }
  } };
}
const ll = { class: "w-full px-4 py-6 sm:py-10" }, cl = { class: "max-w-[min(100%,448px)] mx-auto p-6 bg-white rounded-2xl shadow-xl border border-gray-100" }, ul = { class: "mb-8" }, dl = { class: "text-2xl font-black text-gray-700" }, fl = { class: "text-gray-700" }, ml = {
  key: 0,
  class: "mb-6 p-4 bg-green-50 text-green-700 rounded-lg border border-green-100 text-sm font-bold"
}, pl = {
  key: 1,
  class: "mb-6 p-4 bg-red-50 text-red-700 rounded-lg border border-red-100 text-sm"
}, wl = { class: "space-y-5" }, hl = { class: "block text-sm font-bold text-gray-700 mb-2" }, gl = ["placeholder"], bl = { class: "block text-sm font-bold text-gray-700 mb-2" }, _l = { class: "relative" }, yl = ["type", "placeholder"], vl = ["aria-label"], El = { class: "text-xl leading-none" }, kl = { class: "block text-sm font-bold text-gray-700 mb-2" }, Cl = { class: "relative" }, Ll = ["type", "placeholder"], Tl = { class: "text-xl leading-none" }, Nl = ["disabled"], Al = {
  key: 0,
  class: "text-center text-xs text-red-700 font-medium"
}, im = /* @__PURE__ */ Ne({
  __name: "ChangePasswordPage",
  props: {
    changePasswordApi: {}
  },
  setup(e) {
    const { t } = De(), n = e, { passwordForm: o, isUpdating: s, updateError: r, updateSuccess: a, submitPasswordChange: i } = il(n.changePasswordApi), c = async () => {
      try {
        await i();
      } catch {
      }
    }, d = fe(!1);
    return (_, y) => (G(), X("div", ll, [
      f("div", cl, [
        f("header", ul, [
          f("h2", dl, O(k(t)("security.title")), 1),
          f("p", fl, O(k(t)("security.subtitle")), 1)
        ]),
        k(a) ? (G(), X("div", ml, " ✅ " + O(k(t)("security.successMessage")), 1)) : Be("", !0),
        k(r) ? (G(), X("div", pl, " ❌ " + O(k(r)), 1)) : Be("", !0),
        f("div", wl, [
          f("div", null, [
            f("label", hl, O(k(t)("security.accountLabel")), 1),
            Ke(f("input", {
              "onUpdate:modelValue": y[0] || (y[0] = (h) => k(o).account = h),
              type: "text",
              placeholder: k(t)("security.accountPlaceholder"),
              class: "w-full px-4 py-3 rounded-xl border border-gray-100 focus:ring-2 focus:ring-blue-700 focus:border-transparent transition outline-none text-base"
            }, null, 8, gl), [
              [ut, k(o).account]
            ])
          ]),
          f("div", null, [
            f("label", bl, O(k(t)("security.oldPasswordLabel")), 1),
            f("div", _l, [
              Ke(f("input", {
                "onUpdate:modelValue": y[1] || (y[1] = (h) => k(o).password_old = h),
                type: d.value ? "text" : "password",
                placeholder: k(t)("security.oldPasswordPlaceholder"),
                class: "w-full px-4 py-3 pr-12 rounded-xl border border-gray-100 focus:ring-2 focus:ring-blue-700 focus:border-transparent transition outline-none text-base"
              }, null, 8, yl), [
                [So, k(o).password_old]
              ]),
              f("button", {
                type: "button",
                onClick: y[2] || (y[2] = (h) => d.value = !d.value),
                class: "absolute right-0 top-0 h-full px-4 flex items-center justify-center text-gray-700 active:text-gray-700 transition-colors select-none",
                "aria-label": k(t)("security.togglePassword")
              }, [
                f("span", El, O(d.value ? "🙈" : "👁️"), 1)
              ], 8, vl)
            ])
          ]),
          f("div", null, [
            f("label", kl, O(k(t)("security.newPasswordLabel")), 1),
            f("div", Cl, [
              Ke(f("input", {
                "onUpdate:modelValue": y[3] || (y[3] = (h) => k(o).password = h),
                type: d.value ? "text" : "password",
                placeholder: k(t)("security.newPasswordPlaceholder"),
                class: "w-full px-4 py-3 pr-12 rounded-xl border border-gray-100 focus:ring-2 focus:ring-blue-700 focus:border-transparent transition outline-none text-base"
              }, null, 8, Ll), [
                [So, k(o).password]
              ]),
              f("button", {
                type: "button",
                onClick: y[4] || (y[4] = (h) => d.value = !d.value),
                class: "absolute right-0 top-0 h-full px-4 flex items-center justify-center text-gray-700 active:text-gray-700 transition-colors select-none"
              }, [
                f("span", Tl, O(d.value ? "🙈" : "👁️"), 1)
              ])
            ])
          ]),
          f("button", {
            onClick: c,
            disabled: k(s) || !k(o).account || !k(o).password || !k(o).password_old,
            class: "w-full py-4 rounded-xl font-bold transition-all bg-blue-700 text-white disabled:bg-gray-100 disabled:text-gray-400 active:scale-[0.98]"
          }, O(k(s) ? k(t)("common.processing") : k(t)("security.submitBtn")), 9, Nl),
          !k(s) && (!k(o).account || !k(o).password || !k(o).password_old) ? (G(), X("p", Al, " * " + O(k(t)("security.requiredFieldsNote")), 1)) : Be("", !0)
        ])
      ])
    ]));
  }
});
function xl(e) {
  const t = fe([]), n = fe([]), o = fe(!1), s = fe(null);
  return {
    userList: t,
    adminNames: n,
    loading: o,
    error: s,
    fetchUsers: async () => {
      o.value = !0, s.value = null;
      try {
        const i = await e.getUsersByMerchant();
        t.value = i.users, n.value = i.merchantAdminNames;
      } catch (i) {
        s.value = i.message || "Failed to fetch merchant users";
      } finally {
        o.value = !1;
      }
    },
    toggleUserStatus: async (i) => {
      if (!i.userInfo) {
        s.value = "此使用者尚未建立設定檔";
        return;
      }
      const c = i.userInfo.enabled;
      try {
        i.userInfo.enabled = !i.userInfo.enabled, await e.updateUserStatus(i.username, i.userInfo.enabled);
      } catch (d) {
        i.userInfo.enabled = c, s.value = d.message || "無法更新狀態";
      }
    }
  };
}
/*!
* sweetalert2 v11.26.25
* Released under the MIT License.
*/
function Zs(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function Il(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function cs(e, t) {
  return e.get(Zs(e, t));
}
function Ol(e, t, n) {
  Il(e, t), t.set(e, n);
}
function Pl(e, t, n) {
  return e.set(Zs(e, t), n), n;
}
const Sl = 100, M = {}, Dl = () => {
  M.previousActiveElement instanceof HTMLElement ? (M.previousActiveElement.focus(), M.previousActiveElement = null) : document.body && document.body.focus();
}, Ml = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, o = window.scrollY;
  M.restoreFocusTimeout = setTimeout(() => {
    Dl(), t();
  }, Sl), window.scrollTo(n, o);
}), Qs = "swal2-", $l = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], m = $l.reduce(
  (e, t) => (e[t] = Qs + t, e),
  /** @type {SwalClasses} */
  {}
), Rl = ["success", "warning", "info", "question", "error"], nn = Rl.reduce(
  (e, t) => (e[t] = Qs + t, e),
  /** @type {SwalIcons} */
  {}
), er = "SweetAlert2:", mo = (e) => e.charAt(0).toUpperCase() + e.slice(1), we = (e) => {
  console.warn(`${er} ${typeof e == "object" ? e.join(" ") : e}`);
}, it = (e) => {
  console.error(`${er} ${e}`);
}, us = [], Fl = (e) => {
  us.includes(e) || (us.push(e), we(e));
}, tr = (e, t = null) => {
  Fl(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, hn = (e) => typeof e == "function" ? e() : e, po = (e) => e && typeof e.toPromise == "function", Rt = (e) => po(e) ? e.toPromise() : Promise.resolve(e), wo = (e) => e && Promise.resolve(e) === e, Ul = () => navigator.userAgent.includes("Firefox"), he = () => document.body.querySelector(`.${m.container}`), Ft = (e) => {
  const t = he();
  return t ? t.querySelector(e) : null;
}, ye = (e) => Ft(`.${e}`), W = () => ye(m.popup), vt = () => ye(m.icon), Bl = () => ye(m["icon-content"]), nr = () => ye(m.title), ho = () => ye(m["html-container"]), or = () => ye(m.image), go = () => ye(m["progress-steps"]), gn = () => ye(m["validation-message"]), Se = () => (
  /** @type {HTMLButtonElement} */
  Ft(`.${m.actions} .${m.confirm}`)
), Et = () => (
  /** @type {HTMLButtonElement} */
  Ft(`.${m.actions} .${m.cancel}`)
), lt = () => (
  /** @type {HTMLButtonElement} */
  Ft(`.${m.actions} .${m.deny}`)
), Vl = () => ye(m["input-label"]), kt = () => Ft(`.${m.loader}`), Ut = () => ye(m.actions), sr = () => ye(m.footer), bn = () => ye(m["timer-progress-bar"]), bo = () => ye(m.close), Hl = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, _o = () => {
  const e = W();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((r, a) => {
    const i = parseInt(r.getAttribute("tabindex") || "0"), c = parseInt(a.getAttribute("tabindex") || "0");
    return i > c ? 1 : i < c ? -1 : 0;
  }), o = e.querySelectorAll(Hl), s = Array.from(o).filter((r) => r.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(s))].filter((r) => ge(r));
}, yo = () => He(document.body, m.shown) && !He(document.body, m["toast-shown"]) && !He(document.body, m["no-backdrop"]), _n = () => {
  const e = W();
  return e ? He(e, m.toast) : !1;
}, Wl = () => {
  const e = W();
  return e ? e.hasAttribute("data-loading") : !1;
}, ve = (e, t) => {
  if (e.textContent = "", t) {
    const o = new DOMParser().parseFromString(t, "text/html"), s = o.querySelector("head");
    s && Array.from(s.childNodes).forEach((a) => {
      e.appendChild(a);
    });
    const r = o.querySelector("body");
    r && Array.from(r.childNodes).forEach((a) => {
      a instanceof HTMLVideoElement || a instanceof HTMLAudioElement ? e.appendChild(a.cloneNode(!0)) : e.appendChild(a);
    });
  }
}, He = (e, t) => t ? t.split(/\s+/).every((n) => e.classList.contains(n)) : !1, jl = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(m).includes(n) && !Object.values(nn).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, _e = (e, t, n) => {
  if (jl(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      we(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    H(e, o);
  }
}, yn = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${m.popup} > .${m[t]}`);
    case "checkbox":
      return e.querySelector(`.${m.popup} > .${m.checkbox} input`);
    case "radio":
      return e.querySelector(`.${m.popup} > .${m.radio} input:checked`) || e.querySelector(`.${m.popup} > .${m.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${m.popup} > .${m.range} input`);
    default:
      return e.querySelector(`.${m.popup} > .${m.input}`);
  }
}, rr = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, ar = (e, t, n) => {
  if (!e || !t)
    return;
  const o = typeof t == "string" ? t.split(/\s+/).filter(Boolean) : t;
  (Array.isArray(e) ? e : [e]).forEach((r) => {
    o.forEach((a) => {
      n ? r.classList.add(a) : r.classList.remove(a);
    });
  });
}, H = (e, t) => {
  ar(e, t, !0);
}, Le = (e, t) => {
  ar(e, t, !1);
}, Ye = (e, t) => (
  /** @type {HTMLElement | undefined} */
  Array.from(e.children).find((n) => n instanceof HTMLElement && He(n, t))
), st = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || n === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : (
    /** @type {string} */
    n
  )) : e.style.removeProperty(t);
}, ce = (e, t = "flex") => {
  e && (e.style.display = t);
}, me = (e) => {
  e && (e.style.display = "none");
}, vo = (e, t = "block") => {
  e && new MutationObserver(() => {
    Bt(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, ds = (e, t, n, o) => {
  const s = e.querySelector(t);
  s && s.style.setProperty(n, o);
}, Bt = (e, t, n = "flex") => {
  t ? ce(e, n) : me(e);
}, ge = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), Kl = () => !ge(Se()) && !ge(lt()) && !ge(Et()), Zn = (e) => e.scrollHeight > e.clientHeight, Yl = (e, t) => {
  let n = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; n && n !== t; ) {
    if (Zn(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, ir = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || o > 0;
}, Eo = (e, t = !1) => {
  const n = bn();
  n && ge(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, Gl = () => {
  const e = bn();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
  e.style.width = `${o}%`;
}, ql = () => typeof window > "u" || typeof document > "u", Xl = `
 <div aria-labelledby="${m.title}" aria-describedby="${m["html-container"]}" class="${m.popup}" tabindex="-1">
   <button type="button" class="${m.close}"></button>
   <ul class="${m["progress-steps"]}"></ul>
   <div class="${m.icon}"></div>
   <img class="${m.image}" />
   <h2 class="${m.title}" id="${m.title}"></h2>
   <div class="${m["html-container"]}" id="${m["html-container"]}"></div>
   <input class="${m.input}" id="${m.input}" />
   <input type="file" class="${m.file}" />
   <div class="${m.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${m.select}" id="${m.select}"></select>
   <div class="${m.radio}"></div>
   <label class="${m.checkbox}">
     <input type="checkbox" id="${m.checkbox}" />
     <span class="${m.label}"></span>
   </label>
   <textarea class="${m.textarea}" id="${m.textarea}"></textarea>
   <div class="${m["validation-message"]}" id="${m["validation-message"]}"></div>
   <div class="${m.actions}">
     <div class="${m.loader}"></div>
     <button type="button" class="${m.confirm}"></button>
     <button type="button" class="${m.deny}"></button>
     <button type="button" class="${m.cancel}"></button>
   </div>
   <div class="${m.footer}"></div>
   <div class="${m["timer-progress-bar-container"]}">
     <div class="${m["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), zl = () => {
  const e = he();
  return e ? (e.remove(), Le([document.documentElement, document.body], [
    m["no-backdrop"],
    m["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    m["has-column"]
  ]), !0) : !1;
}, tt = () => {
  M.currentInstance && M.currentInstance.resetValidationMessage();
}, Jl = () => {
  const e = W();
  if (!e)
    return;
  const t = Ye(e, m.input), n = Ye(e, m.file), o = e.querySelector(`.${m.range} input`), s = e.querySelector(`.${m.range} output`), r = Ye(e, m.select), a = e.querySelector(`.${m.checkbox} input`), i = Ye(e, m.textarea);
  t && (t.oninput = tt), n && (n.onchange = tt), r && (r.onchange = tt), a && (a.onchange = tt), i && (i.oninput = tt), o && s && (o.oninput = () => {
    tt(), s.value = o.value;
  }, o.onchange = () => {
    tt(), s.value = o.value;
  });
}, Zl = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, Ql = (e) => {
  const t = W();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, ec = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (H(he(), m.rtl), M.isRTL = !0);
}, tc = (e) => {
  const t = zl();
  if (ql()) {
    it("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = m.container, t && H(n, m["no-transition"]), ve(n, Xl), n.dataset.swal2Theme = e.theme;
  const o = Zl(e.target || "body");
  o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), Ql(e), ec(o), Jl();
}, ko = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? nc(e, t) : e && ve(t, e);
}, nc = (e, t) => {
  "jquery" in e ? oc(t, e) : ve(t, e.toString());
}, oc = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, sc = (e, t) => {
  const n = Ut(), o = kt();
  !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? me(n) : ce(n), _e(n, t, "actions"), rc(n, o, t), ve(o, t.loaderHtml || ""), _e(o, t, "loader"));
};
function rc(e, t, n) {
  const o = Se(), s = lt(), r = Et();
  !o || !s || !r || (Vn(o, "confirm", n), Vn(s, "deny", n), Vn(r, "cancel", n), ac(o, s, r, n), n.reverseButtons && (n.toast ? (e.insertBefore(r, o), e.insertBefore(s, o)) : (e.insertBefore(r, t), e.insertBefore(s, t), e.insertBefore(o, t))));
}
function ac(e, t, n, o) {
  if (!o.buttonsStyling) {
    Le([e, t, n], m.styled);
    return;
  }
  H([e, t, n], m.styled), [[e, "confirm", o.confirmButtonColor], [t, "deny", o.denyButtonColor], [n, "cancel", o.cancelButtonColor]].forEach(([r, a, i]) => {
    i && r.style.setProperty(`--swal2-${a}-button-background-color`, i), ic(r);
  });
}
function ic(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function Vn(e, t, n) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    mo(t)
  );
  Bt(e, n[`show${o}Button`], "inline-block"), ve(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = m[t], _e(e, n, `${t}Button`);
}
const lc = (e, t) => {
  const n = bo();
  n && (ve(n, t.closeButtonHtml || ""), _e(n, t, "closeButton"), Bt(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, cc = (e, t) => {
  const n = he();
  n && (uc(n, t.backdrop), dc(n, t.position), fc(n, t.grow), _e(n, t, "container"));
};
function uc(e, t) {
  typeof t == "string" ? e.style.background = t : t || H([document.documentElement, document.body], m["no-backdrop"]);
}
function dc(e, t) {
  t && (t in m ? H(e, m[t]) : (we('The "position" parameter is not valid, defaulting to "center"'), H(e, m.center)));
}
function fc(e, t) {
  t && H(e, m[`grow-${t}`]);
}
var Y = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap(),
  focusedElement: /* @__PURE__ */ new WeakMap()
};
const mc = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], pc = (e, t) => {
  const n = W();
  if (!n)
    return;
  const o = Y.innerParams.get(e), s = !o || t.input !== o.input;
  mc.forEach((r) => {
    const a = Ye(n, m[r]);
    a && (gc(r, t.inputAttributes), a.className = m[r], s && me(a));
  }), t.input && (s && wc(t), bc(t));
}, wc = (e) => {
  if (!e.input)
    return;
  if (!te[e.input]) {
    it(`Unexpected type of input! Expected ${Object.keys(te).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = lr(e.input);
  if (!t)
    return;
  const n = te[e.input](t, e);
  ce(t), e.inputAutoFocus && setTimeout(() => {
    rr(n);
  });
}, hc = (e) => {
  for (const {
    name: t
  } of Array.from(e.attributes))
    ["id", "type", "value", "style"].includes(t) || e.removeAttribute(t);
}, gc = (e, t) => {
  const n = W();
  if (!n)
    return;
  const o = yn(n, e);
  if (o) {
    hc(o);
    for (const s in t)
      o.setAttribute(s, t[s]);
  }
}, bc = (e) => {
  if (!e.input)
    return;
  const t = lr(e.input);
  t && _e(t, e, "input");
}, Co = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, Vt = (e, t, n) => {
  if (n.inputLabel) {
    const o = document.createElement("label"), s = m["input-label"];
    o.setAttribute("for", e.id), o.className = s, typeof n.customClass == "object" && H(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, lr = (e) => {
  const t = W();
  if (t)
    return Ye(t, m[
      /** @type {SwalClass} */
      e
    ] || m.input);
}, on = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : wo(t) || we(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, te = {};
te.text = te.email = te.password = te.number = te.tel = te.url = te.search = te.date = te["datetime-local"] = te.time = te.week = te.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return on(n, t.inputValue), Vt(n, n, t), Co(n, t), n.type = /** @type {string} */
  t.input, n;
};
te.file = (e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return Vt(n, n, t), Co(n, t), n;
};
te.range = (e, t) => {
  const n = (
    /** @type {HTMLElement} */
    e
  ), o = n.querySelector("input"), s = n.querySelector("output");
  return o && (on(o, t.inputValue), o.type = /** @type {string} */
  t.input, Vt(
    o,
    /** @type {Input} */
    e,
    t
  )), s && on(s, t.inputValue), /** @type {Input} */
  e;
};
te.select = (e, t) => {
  const n = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (n.textContent = "", t.inputPlaceholder) {
    const o = document.createElement("option");
    ve(o, t.inputPlaceholder), o.value = "", o.disabled = !0, o.selected = !0, n.appendChild(o);
  }
  return Vt(n, n, t), n;
};
te.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
te.checkbox = (e, t) => {
  const n = W();
  if (!n)
    throw new Error("Popup not found");
  const o = yn(n, "checkbox");
  if (!o)
    throw new Error("Checkbox input not found");
  o.value = "1", o.checked = !!t.inputValue;
  const r = /** @type {HTMLElement} */ e.querySelector("span");
  if (r) {
    const a = t.inputPlaceholder || t.inputLabel;
    a && ve(r, a);
  }
  return o;
};
te.textarea = (e, t) => {
  const n = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  on(n, t.inputValue), Co(n, t), Vt(n, n, t);
  const o = (s) => parseInt(window.getComputedStyle(s).marginLeft) + parseInt(window.getComputedStyle(s).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const s = W();
      if (!s)
        return;
      const r = parseInt(window.getComputedStyle(s).width), a = () => {
        if (!document.body.contains(n))
          return;
        const i = n.offsetWidth + o(n), c = W();
        c && (i > r ? c.style.width = `${i}px` : st(c, "width", t.width));
      };
      new MutationObserver(a).observe(n, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), n;
};
const _c = (e, t) => {
  const n = ho();
  n && (vo(n), _e(n, t, "htmlContainer"), t.html ? (ko(t.html, n), ce(n, "block")) : t.text ? (n.textContent = t.text, ce(n, "block")) : me(n), pc(e, t));
}, yc = (e, t) => {
  const n = sr();
  n && (vo(n), Bt(n, !!t.footer, "block"), t.footer && ko(t.footer, n), _e(n, t, "footer"));
}, vc = (e, t) => {
  const n = Y.innerParams.get(e), o = vt();
  if (!o)
    return;
  if (n && t.icon === n.icon) {
    ms(o, t), fs(o, t);
    return;
  }
  if (!t.icon && !t.iconHtml) {
    me(o);
    return;
  }
  if (t.icon && Object.keys(nn).indexOf(t.icon) === -1) {
    it(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), me(o);
    return;
  }
  ce(o), ms(o, t), fs(o, t), H(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", cr);
}, fs = (e, t) => {
  for (const [n, o] of Object.entries(nn))
    t.icon !== n && Le(e, o);
  H(e, t.icon && nn[t.icon]), Cc(e, t), cr(), _e(e, t, "icon");
}, cr = () => {
  const e = W();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color");
  e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix").forEach((o) => {
    o.style.backgroundColor = t;
  });
}, Ec = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, kc = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, ms = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, o = "";
  t.iconHtml ? o = ps(t.iconHtml) : t.icon === "success" ? (o = Ec(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = kc : t.icon && (o = ps({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== o.trim() && ve(e, o);
}, Cc = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      ds(e, n, "background-color", t.iconColor);
    ds(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, ps = (e) => `<div class="${m["icon-content"]}">${e}</div>`, Lc = (e, t) => {
  const n = or();
  if (n) {
    if (!t.imageUrl) {
      me(n);
      return;
    }
    ce(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), st(n, "width", t.imageWidth), st(n, "height", t.imageHeight), n.className = m.image, _e(n, t, "image");
  }
};
let Lo = !1, ur = 0, dr = 0, fr = 0, mr = 0;
const Tc = (e) => {
  e.addEventListener("mousedown", sn), document.body.addEventListener("mousemove", rn), e.addEventListener("mouseup", an), e.addEventListener("touchstart", sn), document.body.addEventListener("touchmove", rn), e.addEventListener("touchend", an);
}, Nc = (e) => {
  e.removeEventListener("mousedown", sn), document.body.removeEventListener("mousemove", rn), e.removeEventListener("mouseup", an), e.removeEventListener("touchstart", sn), document.body.removeEventListener("touchmove", rn), e.removeEventListener("touchend", an);
}, sn = (e) => {
  const t = W();
  if (!t)
    return;
  const n = vt();
  if (e.target === t || n && n.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    Lo = !0;
    const o = pr(e);
    ur = o.clientX, dr = o.clientY, fr = parseInt(t.style.insetInlineStart) || 0, mr = parseInt(t.style.insetBlockStart) || 0, H(t, "swal2-dragging");
  }
}, rn = (e) => {
  const t = W();
  if (t && Lo) {
    let {
      clientX: n,
      clientY: o
    } = pr(e);
    const s = n - ur;
    t.style.insetInlineStart = `${fr + (M.isRTL ? -s : s)}px`, t.style.insetBlockStart = `${mr + (o - dr)}px`;
  }
}, an = () => {
  const e = W();
  Lo = !1, Le(e, "swal2-dragging");
}, pr = (e) => {
  const t = e.type.startsWith("touch") ? (
    /** @type {TouchEvent} */
    e.touches[0]
  ) : (
    /** @type {MouseEvent} */
    e
  );
  return {
    clientX: t.clientX,
    clientY: t.clientY
  };
}, Ac = (e, t) => {
  const n = he(), o = W();
  if (!(!n || !o)) {
    if (t.toast) {
      st(n, "width", t.width), o.style.width = "100%";
      const s = kt();
      s && o.insertBefore(s, vt());
    } else
      st(o, "width", t.width);
    st(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), me(gn()), xc(o, t), t.draggable && !t.toast ? (H(o, m.draggable), Tc(o)) : (Le(o, m.draggable), Nc(o));
  }
}, xc = (e, t) => {
  const n = t.showClass || {};
  e.className = `${m.popup} ${ge(e) ? n.popup : ""}`, t.toast ? (H([document.documentElement, document.body], m["toast-shown"]), H(e, m.toast)) : H(e, m.modal), _e(e, t, "popup"), typeof t.customClass == "string" && H(e, t.customClass), t.icon && H(e, m[`icon-${t.icon}`]);
}, Ic = (e, t) => {
  const n = go();
  if (!n)
    return;
  const {
    progressSteps: o,
    currentProgressStep: s
  } = t;
  if (!o || o.length === 0 || s === void 0) {
    me(n);
    return;
  }
  ce(n), n.textContent = "", s >= o.length && we("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((r, a) => {
    const i = Oc(r);
    if (n.appendChild(i), a === s && H(i, m["active-progress-step"]), a !== o.length - 1) {
      const c = Pc(t);
      n.appendChild(c);
    }
  });
}, Oc = (e) => {
  const t = document.createElement("li");
  return H(t, m["progress-step"]), ve(t, e), t;
}, Pc = (e) => {
  const t = document.createElement("li");
  return H(t, m["progress-step-line"]), e.progressStepsDistance && st(t, "width", e.progressStepsDistance), t;
}, Sc = (e, t) => {
  const n = nr();
  n && (vo(n), Bt(n, !!(t.title || t.titleText), "block"), t.title && ko(t.title, n), t.titleText && (n.innerText = t.titleText), _e(n, t, "title"));
}, wr = (e, t) => {
  var n;
  Ac(e, t), cc(e, t), Ic(e, t), vc(e, t), Lc(e, t), Sc(e, t), lc(e, t), _c(e, t), sc(e, t), yc(e, t);
  const o = W();
  typeof t.didRender == "function" && o && t.didRender(o), (n = M.eventEmitter) === null || n === void 0 || n.emit("didRender", o);
}, Dc = () => ge(W()), hr = () => {
  var e;
  return (e = Se()) === null || e === void 0 ? void 0 : e.click();
}, Mc = () => {
  var e;
  return (e = lt()) === null || e === void 0 ? void 0 : e.click();
}, $c = () => {
  var e;
  return (e = Et()) === null || e === void 0 ? void 0 : e.click();
}, Ct = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), gr = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, Rc = (e, t, n) => {
  if (gr(e), !t.toast) {
    const o = (r) => Uc(t, r, n);
    e.keydownHandler = o;
    const s = t.keydownListenerCapture ? window : W();
    if (s) {
      e.keydownTarget = s, e.keydownListenerCapture = t.keydownListenerCapture;
      const r = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        o
      );
      e.keydownTarget.addEventListener("keydown", r, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, Qn = (e, t) => {
  var n;
  const o = _o();
  return o.length ? (e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus(), !(Ul() && o[e] instanceof HTMLIFrameElement)) : ((n = W()) === null || n === void 0 || n.focus(), !0);
}, br = ["ArrowRight", "ArrowDown"], Fc = ["ArrowLeft", "ArrowUp"], Uc = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? Bc(t, e) : t.key === "Tab" ? Vc(t) : [...br, ...Fc].includes(t.key) ? Hc(t.key) : t.key === "Escape" && Wc(t, e, n)));
}, Bc = (e, t) => {
  if (!hn(t.allowEnterKey))
    return;
  const n = W();
  if (!n || !t.input)
    return;
  const o = yn(n, t.input);
  if (e.target && o && e.target instanceof HTMLElement && e.target.outerHTML === o.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    hr(), e.preventDefault();
  }
}, Vc = (e) => {
  const t = e.target, o = _o().findIndex((r) => r === t);
  let s = !0;
  e.shiftKey ? s = Qn(o, -1) : s = Qn(o, 1), e.stopPropagation(), s && e.preventDefault();
}, Hc = (e) => {
  const t = Ut(), n = Se(), o = lt(), s = Et();
  if (!t || !n || !o || !s)
    return;
  const r = [n, o, s];
  if (document.activeElement instanceof HTMLElement && !r.includes(document.activeElement))
    return;
  const a = br.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let i = document.activeElement;
  if (i) {
    for (let c = 0; c < t.children.length; c++) {
      if (i = i[a], !i)
        return;
      if (i instanceof HTMLButtonElement && ge(i))
        break;
    }
    i instanceof HTMLButtonElement && i.focus();
  }
}, Wc = (e, t, n) => {
  e.preventDefault(), hn(t.allowEscapeKey) && n(Ct.esc);
};
var bt = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const jc = () => {
  const e = he();
  Array.from(document.body.children).forEach((n) => {
    n.contains(e) || (n.hasAttribute("aria-hidden") && n.setAttribute("data-previous-aria-hidden", n.getAttribute("aria-hidden") || ""), n.setAttribute("aria-hidden", "true"));
  });
}, _r = () => {
  Array.from(document.body.children).forEach((t) => {
    t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
  });
}, To = typeof window < "u" && !!window.GestureEvent, Kc = To && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, Yc = () => {
  if (To && !He(document.body, m.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, H(document.body, m.iosfix), Gc();
  }
}, Gc = () => {
  const e = he();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = qc(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, qc = (e) => {
  const t = e.target, n = he(), o = ho();
  return !n || !o || Xc(e) || zc(e) ? !1 : t === n || !Zn(n) && t instanceof HTMLElement && !Yl(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(Zn(o) && // #1944
  o.contains(t));
}, Xc = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), zc = (e) => e.touches && e.touches.length > 1, Jc = () => {
  if (He(document.body, m.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    Le(document.body, m.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, Zc = () => {
  const e = document.createElement("div");
  e.className = m["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let pt = null;
const Qc = (e) => {
  pt === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (pt = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${pt + Zc()}px`);
}, eu = () => {
  pt !== null && (document.body.style.paddingRight = `${pt}px`, pt = null);
};
function yr(e, t, n, o) {
  _n() ? ws(e, o) : (Ml(n).then(() => ws(e, o)), gr(M)), To ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), yo() && (eu(), Jc(), _r()), tu();
}
function tu() {
  Le([document.documentElement, document.body], [m.shown, m["height-auto"], m["no-backdrop"], m["toast-shown"]]);
}
function Ge(e) {
  e = ou(e);
  const t = bt.swalPromiseResolve.get(this), n = nu(this);
  this.isAwaitingPromise ? e.isDismissed || (Ht(this), t(e)) : n && t(e);
}
const nu = (e) => {
  const t = W();
  if (!t)
    return !1;
  const n = Y.innerParams.get(e);
  if (!n || He(t, n.hideClass.popup))
    return !1;
  Le(t, n.showClass.popup), H(t, n.hideClass.popup);
  const o = he();
  return Le(o, n.showClass.backdrop), H(o, n.hideClass.backdrop), su(e, t, n), !0;
};
function vr(e) {
  const t = bt.swalPromiseReject.get(this);
  Ht(this), t && t(e);
}
const Ht = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, Y.innerParams.get(e) || e._destroy());
}, ou = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), su = (e, t, n) => {
  var o;
  const s = he(), r = ir(t);
  typeof n.willClose == "function" && n.willClose(t), (o = M.eventEmitter) === null || o === void 0 || o.emit("willClose", t), r && s ? ru(e, t, s, !!n.returnFocus, n.didClose) : s && yr(e, s, !!n.returnFocus, n.didClose);
}, ru = (e, t, n, o, s) => {
  M.swalCloseEventFinishedCallback = yr.bind(null, e, n, o, s);
  const r = function(a) {
    if (a.target === t) {
      var i;
      (i = M.swalCloseEventFinishedCallback) === null || i === void 0 || i.call(M), delete M.swalCloseEventFinishedCallback, t.removeEventListener("animationend", r), t.removeEventListener("transitionend", r);
    }
  };
  t.addEventListener("animationend", r), t.addEventListener("transitionend", r);
}, ws = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = M.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, _t = (e) => {
  let t = W();
  if (t || new dn(), t = W(), !t)
    return;
  const n = kt();
  _n() ? me(vt()) : au(t, e), ce(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, au = (e, t) => {
  const n = Ut(), o = kt();
  !n || !o || (!t && ge(Se()) && (t = Se()), ce(n), t && (me(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), H([e, n], m.loading));
}, iu = (e, t) => {
  t.input === "select" || t.input === "radio" ? fu(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (po(t.inputValue) || wo(t.inputValue)) && (_t(Se()), mu(e, t));
}, lu = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return cu(n);
    case "radio":
      return uu(n);
    case "file":
      return du(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, cu = (e) => e.checked ? 1 : 0, uu = (e) => e.checked ? e.value : null, du = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, fu = (e, t) => {
  const n = W();
  if (!n)
    return;
  const o = (s) => {
    t.input === "select" ? pu(n, eo(s), t) : t.input === "radio" && wu(n, eo(s), t);
  };
  po(t.inputOptions) || wo(t.inputOptions) ? (_t(Se()), Rt(t.inputOptions).then((s) => {
    e.hideLoading(), o(s);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : it(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, mu = (e, t) => {
  const n = e.getInput();
  n && (me(n), Rt(t.inputValue).then((o) => {
    n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, ce(n), n.focus(), e.hideLoading();
  }).catch((o) => {
    it(`Error in inputValue promise: ${o}`), n.value = "", ce(n), n.focus(), e.hideLoading();
  }));
};
function pu(e, t, n) {
  const o = Ye(e, m.select);
  if (!o)
    return;
  const s = (r, a, i) => {
    const c = document.createElement("option");
    c.value = i, ve(c, a), c.selected = Er(i, n.inputValue), r.appendChild(c);
  };
  t.forEach((r) => {
    const a = r[0], i = r[1];
    if (Array.isArray(i)) {
      const c = document.createElement("optgroup");
      c.label = a, c.disabled = !1, o.appendChild(c), i.forEach((d) => s(c, d[1], d[0]));
    } else
      s(o, i, a);
  }), o.focus();
}
function wu(e, t, n) {
  const o = Ye(e, m.radio);
  if (!o)
    return;
  t.forEach((r) => {
    const a = r[0], i = r[1], c = document.createElement("input"), d = document.createElement("label");
    c.type = "radio", c.name = m.radio, c.value = a, Er(a, n.inputValue) && (c.checked = !0);
    const _ = document.createElement("span");
    ve(_, i), _.className = m.label, d.appendChild(c), d.appendChild(_), o.appendChild(d);
  });
  const s = o.querySelectorAll("input");
  s.length && s[0].focus();
}
const eo = (e) => (e instanceof Map ? Array.from(e) : Object.entries(e)).map(([n, o]) => [n, typeof o == "object" ? eo(o) : o]), Er = (e, t) => !!t && t != null && t.toString() === e.toString(), hu = (e) => {
  const t = Y.innerParams.get(e);
  e.disableButtons(), t.input ? kr(e, "confirm") : Ao(e, !0);
}, gu = (e) => {
  const t = Y.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? kr(e, "deny") : No(e, !1);
}, bu = (e, t) => {
  e.disableButtons(), t(Ct.cancel);
}, kr = (e, t) => {
  const n = Y.innerParams.get(e);
  if (!n.input) {
    it(`The "input" parameter is needed to be set when using returnInputValueOn${mo(t)}`);
    return;
  }
  const o = e.getInput(), s = lu(e, n);
  n.inputValidator ? _u(e, s, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? No(e, s) : Ao(e, s);
}, _u = (e, t, n) => {
  const o = Y.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => Rt(o.inputValidator(t, o.validationMessage))).then((r) => {
    e.enableButtons(), e.enableInput(), r ? e.showValidationMessage(r) : n === "deny" ? No(e, t) : Ao(e, t);
  });
}, No = (e, t) => {
  const n = Y.innerParams.get(e);
  n.showLoaderOnDeny && _t(lt()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => Rt(n.preDeny(t, n.validationMessage))).then((s) => {
    s === !1 ? (e.hideLoading(), Ht(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof s > "u" ? t : s
      }
    );
  }).catch((s) => Cr(e, s))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, hs = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, Cr = (e, t) => {
  e.rejectPromise(t);
}, Ao = (e, t) => {
  const n = Y.innerParams.get(e);
  n.showLoaderOnConfirm && _t(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => Rt(n.preConfirm(t, n.validationMessage))).then((s) => {
    ge(gn()) || s === !1 ? (e.hideLoading(), Ht(e)) : hs(e, typeof s > "u" ? t : s);
  }).catch((s) => Cr(e, s))) : hs(e, t);
};
function ln() {
  const e = Y.innerParams.get(this);
  if (!e)
    return;
  const t = Y.domCache.get(this);
  me(t.loader), _n() ? e.icon && ce(vt()) : yu(t), Le([t.popup, t.actions], m.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), this.enableButtons();
}
const yu = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), n = t ? e.popup.getElementsByClassName(t) : [];
  n.length ? ce(
    /** @type {HTMLElement} */
    n[0],
    "inline-block"
  ) : Kl() && me(e.actions);
};
function Lr() {
  const e = Y.innerParams.get(this), t = Y.domCache.get(this);
  return t ? yn(t.popup, e.input) : null;
}
function Tr(e, t, n) {
  const o = Y.domCache.get(e);
  t.forEach((s) => {
    o[s].disabled = n;
  });
}
function Nr(e, t) {
  const n = W();
  !n || !e || (e.type === "radio" ? n.querySelectorAll(`[name="${m.radio}"]`).forEach((s) => {
    s.disabled = t;
  }) : e.disabled = t);
}
function Ar() {
  Tr(this, ["confirmButton", "denyButton", "cancelButton"], !1);
  const e = Y.focusedElement.get(this);
  e instanceof HTMLElement && document.activeElement === document.body && e.focus(), Y.focusedElement.delete(this);
}
function xr() {
  Y.focusedElement.set(this, document.activeElement), Tr(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function Ir() {
  Nr(this.getInput(), !1);
}
function Or() {
  Nr(this.getInput(), !0);
}
function Pr(e) {
  const t = Y.domCache.get(this), n = Y.innerParams.get(this);
  ve(t.validationMessage, e), t.validationMessage.className = m["validation-message"], n.customClass && n.customClass.validationMessage && H(t.validationMessage, n.customClass.validationMessage), ce(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", m["validation-message"]), rr(o), H(o, m.inputerror));
}
function Sr() {
  const e = Y.domCache.get(this);
  e.validationMessage && me(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), Le(t, m.inputerror));
}
const qe = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, vu = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], Eu = {
  allowEnterKey: void 0
}, ku = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], Dr = (e) => Object.prototype.hasOwnProperty.call(qe, e), Mr = (e) => vu.indexOf(e) !== -1, $r = (e) => Eu[e], Cu = (e) => {
  Dr(e) || we(`Unknown parameter "${e}"`);
}, Lu = (e) => {
  ku.includes(e) && we(`The parameter "${e}" is incompatible with toasts`);
}, Tu = (e) => {
  const t = $r(e);
  t && tr(e, t);
}, Rr = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && we('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && we(`Invalid theme "${e.theme}"`);
  for (const t in e)
    Cu(t), e.toast && Lu(t), Tu(t);
};
function Fr(e) {
  const t = he(), n = W(), o = Y.innerParams.get(this);
  if (!n || He(n, o.hideClass.popup)) {
    we("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const s = Nu(e), r = Object.assign({}, o, s);
  Rr(r), t && (t.dataset.swal2Theme = r.theme), wr(this, r), Y.innerParams.set(this, r), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const Nu = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    if (Mr(n)) {
      const o = (
        /** @type {Record<string, any>} */
        e
      );
      t[n] = o[n];
    } else
      we(`Invalid parameter to update: ${n}`);
  }), t;
};
function Ur() {
  var e;
  const t = Y.domCache.get(this), n = Y.innerParams.get(this);
  if (!n) {
    Br(this);
    return;
  }
  t.popup && M.swalCloseEventFinishedCallback && (M.swalCloseEventFinishedCallback(), delete M.swalCloseEventFinishedCallback), typeof n.didDestroy == "function" && n.didDestroy(), (e = M.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), Au(this);
}
const Au = (e) => {
  Br(e), delete e.params, delete M.keydownHandler, delete M.keydownTarget, delete M.currentInstance;
}, Br = (e) => {
  e.isAwaitingPromise ? (Hn(Y, e), e.isAwaitingPromise = !0) : (Hn(bt, e), Hn(Y, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, Hn = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var xu = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: Ur,
  close: Ge,
  closeModal: Ge,
  closePopup: Ge,
  closeToast: Ge,
  disableButtons: xr,
  disableInput: Or,
  disableLoading: ln,
  enableButtons: Ar,
  enableInput: Ir,
  getInput: Lr,
  handleAwaitingPromise: Ht,
  hideLoading: ln,
  rejectPromise: vr,
  resetValidationMessage: Sr,
  showValidationMessage: Pr,
  update: Fr
});
const Iu = (e, t, n) => {
  e.toast ? Ou(e, t, n) : (Su(t), Du(t), Mu(e, t, n));
}, Ou = (e, t, n) => {
  t.popup.onclick = () => {
    e && (Pu(e) || e.timer || e.input) || n(Ct.close);
  };
}, Pu = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let cn = !1;
const Su = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (cn = !0);
    };
  };
}, Du = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (cn = !0);
    };
  };
}, Mu = (e, t, n) => {
  t.container.onclick = (o) => {
    if (cn) {
      cn = !1;
      return;
    }
    o.target === t.container && hn(e.allowOutsideClick) && n(Ct.backdrop);
  };
}, $u = (e) => typeof e == "object" && e !== null && "jquery" in e, gs = (e) => e instanceof Element || $u(e), Ru = (e) => {
  const t = {};
  return typeof e[0] == "object" && !gs(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, o) => {
    const s = e[o];
    typeof s == "string" || gs(s) ? t[n] = s : s !== void 0 && it(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof s}`);
  }), /** @type {SweetAlertOptions} */
  t;
};
function Fu(...e) {
  return new this(...e);
}
function Uu(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(o, s) {
      return super._main(o, Object.assign({}, e, s));
    }
  }
  return t;
}
const Bu = () => M.timeout && M.timeout.getTimerLeft(), Vr = () => {
  if (M.timeout)
    return Gl(), M.timeout.stop();
}, Hr = () => {
  if (M.timeout) {
    const e = M.timeout.start();
    return Eo(e), e;
  }
}, Vu = () => {
  const e = M.timeout;
  return e && (e.running ? Vr() : Hr());
}, Hu = (e) => {
  if (M.timeout) {
    const t = M.timeout.increase(e);
    return Eo(t, !0), t;
  }
}, Wu = () => !!(M.timeout && M.timeout.isRunning());
let bs = !1;
const to = {};
function ju(e = "data-swal-template") {
  to[e] = this, bs || (document.body.addEventListener("click", Ku), bs = !0);
}
const Ku = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const n in to) {
      const o = t.getAttribute && t.getAttribute(n);
      if (o) {
        to[n].fire({
          template: o
        });
        return;
      }
    }
};
class Yu {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const o = this._getHandlersByEventName(t);
    o.includes(n) || o.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const o = (...s) => {
      this.removeListener(t, o), n.apply(this, s);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, n);
        } catch (s) {
          console.error(s);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const o = this._getHandlersByEventName(t), s = o.indexOf(n);
    s > -1 && o.splice(s, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
M.eventEmitter = new Yu();
const Gu = (e, t) => {
  M.eventEmitter && M.eventEmitter.on(e, t);
}, qu = (e, t) => {
  M.eventEmitter && M.eventEmitter.once(e, t);
}, Xu = (e, t) => {
  if (M.eventEmitter) {
    if (!e) {
      M.eventEmitter.reset();
      return;
    }
    t ? M.eventEmitter.removeListener(e, t) : M.eventEmitter.removeAllListeners(e);
  }
};
var zu = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: Ru,
  bindClickHandler: ju,
  clickCancel: $c,
  clickConfirm: hr,
  clickDeny: Mc,
  enableLoading: _t,
  fire: Fu,
  getActions: Ut,
  getCancelButton: Et,
  getCloseButton: bo,
  getConfirmButton: Se,
  getContainer: he,
  getDenyButton: lt,
  getFocusableElements: _o,
  getFooter: sr,
  getHtmlContainer: ho,
  getIcon: vt,
  getIconContent: Bl,
  getImage: or,
  getInputLabel: Vl,
  getLoader: kt,
  getPopup: W,
  getProgressSteps: go,
  getTimerLeft: Bu,
  getTimerProgressBar: bn,
  getTitle: nr,
  getValidationMessage: gn,
  increaseTimer: Hu,
  isDeprecatedParameter: $r,
  isLoading: Wl,
  isTimerRunning: Wu,
  isUpdatableParameter: Mr,
  isValidParameter: Dr,
  isVisible: Dc,
  mixin: Uu,
  off: Xu,
  on: Gu,
  once: qu,
  resumeTimer: Hr,
  showLoading: _t,
  stopTimer: Vr,
  toggleTimer: Vu
});
class Ju {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const Wr = ["swal-title", "swal-html", "swal-footer"], Zu = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return ad(n), Object.assign(Qu(n), ed(n), td(n), nd(n), od(n), sd(n), rd(n, Wr));
}, Qu = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((o) => {
    at(o, ["name", "value"]);
    const s = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), r = o.getAttribute("value");
    !s || !r || (s in qe && typeof qe[
      /** @type {keyof typeof defaultParams} */
      s
    ] == "boolean" ? t[s] = r !== "false" : s in qe && typeof qe[
      /** @type {keyof typeof defaultParams} */
      s
    ] == "object" ? t[s] = JSON.parse(r) : t[s] = r);
  }), t;
}, ed = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((o) => {
    const s = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), r = o.getAttribute("value");
    !s || !r || (t[s] = new Function(`return ${r}`)());
  }), t;
}, td = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((o) => {
    at(o, ["type", "color", "aria-label"]);
    const s = o.getAttribute("type");
    if (!s || !["confirm", "cancel", "deny"].includes(s))
      return;
    t[`${s}ButtonText`] = o.innerHTML, t[`show${mo(s)}Button`] = !0;
    const r = o.getAttribute("color");
    r !== null && (t[`${s}ButtonColor`] = r);
    const a = o.getAttribute("aria-label");
    a !== null && (t[`${s}ButtonAriaLabel`] = a);
  }), t;
}, nd = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  if (n) {
    at(n, ["src", "width", "height", "alt"]);
    const o = n.getAttribute("src");
    o !== null && (t.imageUrl = o || void 0);
    const s = n.getAttribute("width");
    s !== null && (t.imageWidth = s || void 0);
    const r = n.getAttribute("height");
    r !== null && (t.imageHeight = r || void 0);
    const a = n.getAttribute("alt");
    a !== null && (t.imageAlt = a || void 0);
  }
  return t;
}, od = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (at(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, sd = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (at(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((s) => {
    at(s, ["value"]);
    const r = s.getAttribute("value");
    if (!r)
      return;
    const a = s.innerHTML;
    t.inputOptions[r] = a;
  })), t;
}, rd = (e, t) => {
  const n = {};
  for (const o in t) {
    const s = t[o], r = e.querySelector(s);
    r && (at(r, []), n[s.replace(/^swal-/, "")] = r.innerHTML.trim());
  }
  return n;
}, ad = (e) => {
  const t = Wr.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const o = n.tagName.toLowerCase();
    t.includes(o) || we(`Unrecognized element <${o}>`);
  });
}, at = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && we([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, jr = 10, id = (e) => {
  var t, n;
  const o = he(), s = W();
  if (!o || !s)
    return;
  typeof e.willOpen == "function" && e.willOpen(s), (t = M.eventEmitter) === null || t === void 0 || t.emit("willOpen", s);
  const a = window.getComputedStyle(document.body).overflowY;
  if (ud(o, s, e), setTimeout(() => {
    ld(o, s);
  }, jr), yo() && (cd(o, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, a), jc()), Kc && e.backdrop === !1 && s.scrollHeight > o.clientHeight && (o.style.pointerEvents = "auto"), !_n() && !M.previousActiveElement && (M.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const i = e.didOpen;
    setTimeout(() => i(s));
  }
  (n = M.eventEmitter) === null || n === void 0 || n.emit("didOpen", s);
}, un = (e) => {
  const t = W();
  if (!t || e.target !== t)
    return;
  const n = he();
  n && (t.removeEventListener("animationend", un), t.removeEventListener("transitionend", un), n.style.overflowY = "auto", Le(n, m["no-transition"]));
}, ld = (e, t) => {
  ir(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", un), t.addEventListener("transitionend", un)) : e.style.overflowY = "auto";
}, cd = (e, t, n) => {
  Yc(), t && n !== "hidden" && Qc(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, ud = (e, t, n) => {
  var o;
  (o = n.showClass) !== null && o !== void 0 && o.backdrop && H(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), ce(t, "grid"), setTimeout(() => {
    var s;
    (s = n.showClass) !== null && s !== void 0 && s.popup && H(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, jr)) : ce(t, "grid"), H([document.documentElement, document.body], m.shown), n.heightAuto && n.backdrop && !n.toast && H([document.documentElement, document.body], m["height-auto"]);
};
var _s = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function dd(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = _s.email), e.input === "url" && (e.inputValidator = _s.url));
}
function fd(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (we('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function md(e) {
  dd(e), e.showLoaderOnConfirm && !e.preConfirm && we(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), fd(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), tc(e);
}
let Ie;
var qt = /* @__PURE__ */ new WeakMap();
class se {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (Ol(
      this,
      qt,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    Ie = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, Pl(qt, this, this._main(Ie.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, n = {}) {
    if (Rr(Object.assign({}, n, t)), M.currentInstance) {
      const r = bt.swalPromiseResolve.get(M.currentInstance), {
        isAwaitingPromise: a
      } = M.currentInstance;
      M.currentInstance._destroy(), a || r({
        isDismissed: !0
      }), yo() && _r();
    }
    M.currentInstance = Ie;
    const o = wd(t, n);
    md(o), Object.freeze(o), M.timeout && (M.timeout.stop(), delete M.timeout), clearTimeout(M.restoreFocusTimeout);
    const s = hd(Ie);
    return wr(Ie, o), Y.innerParams.set(Ie, o), pd(Ie, s, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  // oxlint-disable-next-line unicorn/no-thenable
  then(t) {
    return cs(qt, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return cs(qt, this).finally(t);
  }
}
const pd = (e, t, n) => new Promise((o, s) => {
  const r = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  bt.swalPromiseResolve.set(e, o), bt.swalPromiseReject.set(e, s), t.confirmButton.onclick = () => {
    hu(e);
  }, t.denyButton.onclick = () => {
    gu(e);
  }, t.cancelButton.onclick = () => {
    bu(e, r);
  }, t.closeButton.onclick = () => {
    r(Ct.close);
  }, Iu(n, t, r), Rc(M, n, r), iu(e, n), id(n), gd(M, n, r), bd(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), wd = (e, t) => {
  const n = Zu(e), o = Object.assign({}, qe, t, n, e);
  return o.showClass = Object.assign({}, qe.showClass, o.showClass), o.hideClass = Object.assign({}, qe.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, hd = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        W()
      ),
      container: (
        /** @type {HTMLElement} */
        he()
      ),
      actions: (
        /** @type {HTMLElement} */
        Ut()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        Se()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        lt()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        Et()
      ),
      loader: (
        /** @type {HTMLElement} */
        kt()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        bo()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        gn()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        go()
      )
    }
  );
  return Y.domCache.set(e, t), t;
}, gd = (e, t, n) => {
  const o = bn();
  me(o), t.timer && (e.timeout = new Ju(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && o && (ce(o), _e(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && Eo(
      /** @type {number} */
      t.timer
    );
  })));
}, bd = (e, t) => {
  if (!t.toast) {
    if (!hn(t.allowEnterKey)) {
      tr("allowEnterKey", "preConfirm: () => false"), e.popup.focus();
      return;
    }
    _d(e) || yd(e, t) || Qn(-1, 1);
  }
}, _d = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && ge(n))
      return n.focus(), !0;
  return !1;
}, yd = (e, t) => t.focusDeny && ge(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && ge(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && ge(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1;
se.prototype.disableButtons = xr;
se.prototype.enableButtons = Ar;
se.prototype.getInput = Lr;
se.prototype.disableInput = Or;
se.prototype.enableInput = Ir;
se.prototype.hideLoading = ln;
se.prototype.disableLoading = ln;
se.prototype.showValidationMessage = Pr;
se.prototype.resetValidationMessage = Sr;
se.prototype.close = Ge;
se.prototype.closePopup = Ge;
se.prototype.closeModal = Ge;
se.prototype.closeToast = Ge;
se.prototype.rejectPromise = vr;
se.prototype.update = Fr;
se.prototype._destroy = Ur;
Object.assign(se, zu);
Object.keys(xu).forEach((e) => {
  se[e] = function(...t) {
    if (Ie && Ie[e])
      return Ie[e](...t);
  };
});
se.DismissReason = Ct;
se.version = "11.26.25";
const dn = se;
dn.default = dn;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:auto}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:auto}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
const vd = { class: "merchant-lib-container" }, Ed = { class: "lib-header" }, kd = { class: "header-content" }, Cd = { class: "lib-title" }, Ld = { class: "admin-chip-container" }, Td = { class: "lib-description" }, Nd = {
  key: 0,
  class: "status-box error"
}, Ad = { class: "info-list" }, xd = { class: "item-row" }, Id = { class: "username" }, Od = { class: "row-actions" }, Pd = ["title"], Sd = ["checked", "onChange"], Dd = { class: "role-dots" }, Md = ["title"], $d = { class: "lib-footer" }, Rd = /* @__PURE__ */ Ne({
  __name: "MerchantUserPage",
  props: {
    userApi: {}
  },
  setup(e) {
    const { t } = De(), n = e, { userList: o, adminNames: s, loading: r, error: a, fetchUsers: i, toggleUserStatus: c } = xl(n.userApi);
    ys(async () => {
      await i();
    });
    const d = async (_) => {
      try {
        await c(_), await dn.fire({
          icon: "success",
          title: t("personnel.updateSuccess"),
          timer: 1e3,
          showConfirmButton: !1
        });
      } catch {
      }
    };
    return (_, y) => (G(), X("section", vd, [
      f("header", Ed, [
        f("div", kd, [
          f("h1", Cd, O(k(t)("personnel.title")), 1),
          f("div", Ld, [
            (G(!0), X(nt, null, Ot(k(s), (h) => (G(), X("span", {
              key: h,
              class: "admin-chip"
            }, O(k(t)("personnel.adminLabel")) + ": " + O(h), 1))), 128))
          ])
        ]),
        f("p", Td, O(k(t)("personnel.subtitle")), 1)
      ]),
      k(a) ? (G(), X("div", Nd, O(k(a)), 1)) : Be("", !0),
      f("div", Ad, [
        k(r) ? (G(), X(nt, { key: 0 }, Ot(3, (h) => f("div", {
          key: h,
          class: "list-item-skeleton"
        }, [...y[1] || (y[1] = [
          f("div", { class: "skeleton-line wide" }, null, -1),
          f("div", { class: "skeleton-line medium" }, null, -1)
        ])])), 64)) : (G(!0), X(nt, { key: 1 }, Ot(k(o), (h) => {
          var N;
          return G(), X("div", {
            key: h.id,
            class: "list-item"
          }, [
            f("div", xd, [
              f("span", Id, O(h.username), 1),
              f("div", Od, [
                h.roles.some((D) => D.Name === "ROLE_MERCHANT") ? Be("", !0) : (G(), X("label", {
                  key: 0,
                  class: "switch",
                  title: k(t)("personnel.toggleStatus")
                }, [
                  f("input", {
                    type: "checkbox",
                    checked: (N = h.userInfo) == null ? void 0 : N.enabled,
                    onChange: (D) => d(h)
                  }, null, 40, Sd),
                  y[2] || (y[2] = f("span", { class: "slider round" }, null, -1))
                ], 8, Pd)),
                f("div", Dd, [
                  (G(!0), X(nt, null, Ot(h.roles, (D) => (G(), X("span", {
                    key: D.id,
                    class: Zr(["role-dot", { "is-merchant": D.Name === "ROLE_MERCHANT" }]),
                    title: D.Name === "ROLE_MERCHANT" ? k(t)("personnel.roleAdmin") : k(t)("personnel.roleStaff")
                  }, null, 10, Md))), 128))
                ])
              ])
            ])
          ]);
        }), 128))
      ]),
      f("footer", $d, [
        f("button", {
          onClick: y[0] || (y[0] = //@ts-ignore
          (...h) => k(i) && k(i)(...h)),
          class: "btn-refresh"
        }, O(k(t)("personnel.refreshBtn")), 1)
      ])
    ]));
  }
}), xo = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, s] of t)
    n[o] = s;
  return n;
}, lm = /* @__PURE__ */ xo(Rd, [["__scopeId", "data-v-390fe32a"]]);
function Fd(e) {
  const t = fe(!1), n = fe(null), o = fe(!1);
  return {
    isDeleting: t,
    securityError: n,
    deletionSuccess: o,
    requestDeletion: async () => {
      var r, a;
      t.value = !0, n.value = null;
      try {
        const i = await e.requestAccountDeletion();
        return o.value = !0, i;
      } catch (i) {
        throw n.value = ((a = (r = i.response) == null ? void 0 : r.data) == null ? void 0 : a.message) || "請求刪除失敗，請稍後再試", i;
      } finally {
        t.value = !1;
      }
    }
  };
}
const Ud = { class: "p-6 bg-white rounded-2xl shadow-xl border border-gray-100" }, Bd = { class: "text-xl font-black text-red-600 mb-4" }, Vd = { key: 0 }, Hd = { class: "text-gray-700 mb-6 leading-relaxed space-y-2" }, Wd = { class: "list-disc list-inside text-sm text-gray-500" }, jd = {
  key: 0,
  class: "mb-4 p-4 bg-red-50 text-red-700 rounded-lg border border-red-100 text-sm"
}, Kd = { class: "flex gap-3" }, Yd = ["disabled"], Gd = ["disabled"], qd = {
  key: 1,
  class: "text-center py-4"
}, Xd = { class: "text-gray-800 font-bold mb-6" }, zd = /* @__PURE__ */ Ne({
  __name: "AccountDeletionModal",
  props: {
    userSecurityApi: {}
  },
  emits: ["cancel", "logout"],
  setup(e, { emit: t }) {
    const { t: n } = De(), o = e, { isDeleting: s, securityError: r, deletionSuccess: a, requestDeletion: i } = Fd(o.userSecurityApi), c = async () => {
      try {
        await i();
      } catch {
      }
    };
    return (d, _) => (G(), X("div", Ud, [
      f("h2", Bd, O(k(n)("security.deleteAccountTitle")), 1),
      k(a) ? (G(), X("div", qd, [
        _[2] || (_[2] = f("div", { class: "text-green-500 text-5xl mb-4" }, "✅", -1)),
        f("p", Xd, O(k(n)("security.deleteRequestSuccess")), 1),
        f("button", {
          onClick: _[1] || (_[1] = (y) => d.$emit("logout")),
          class: "w-full py-4 bg-gray-800 text-white rounded-xl font-bold active:scale-[0.98] transition-transform"
        }, O(k(n)("security.logoutAndConfirm")), 1)
      ])) : (G(), X("div", Vd, [
        f("div", Hd, [
          f("p", null, O(k(n)("security.deleteAccountConfirm")), 1),
          f("ul", Wd, [
            f("li", null, O(k(n)("security.deleteEffectSuspend")), 1),
            f("li", null, O(k(n)("security.deleteEffectWipeout")), 1),
            f("li", null, O(k(n)("security.deleteEffectIrreversible")), 1)
          ])
        ]),
        k(r) ? (G(), X("div", jd, " ❌ " + O(k(r)), 1)) : Be("", !0),
        f("div", Kd, [
          f("button", {
            onClick: _[0] || (_[0] = (y) => d.$emit("cancel")),
            disabled: k(s),
            class: "flex-1 py-3 border border-gray-300 rounded-xl font-bold text-gray-600 hover:bg-gray-50 transition-colors"
          }, O(k(n)("common.cancel")), 9, Yd),
          f("button", {
            onClick: c,
            disabled: k(s),
            class: "flex-1 py-3 bg-red-600 text-white rounded-xl font-bold shadow-lg shadow-red-100 active:scale-[0.98] transition-all disabled:bg-gray-100 disabled:text-gray-400"
          }, O(k(s) ? k(n)("common.processing") : k(n)("security.confirmDeleteBtn")), 9, Gd)
        ])
      ]))
    ]));
  }
}), Jd = { class: "user-security-panel" }, Zd = ["aria-label"], Qd = { class: "flex items-center gap-3" }, ef = { class: "text-left" }, tf = { class: "font-bold text-base leading-tight" }, nf = { class: "text-xs text-red-400 mt-1" }, of = { class: "w-full max-w-[min(100%,384px)] animate-in fade-in zoom-in duration-200" }, cm = /* @__PURE__ */ Ne({
  __name: "UserSecurityPanel",
  props: {
    userSecurityApi: {}
  },
  emits: ["onLogoutRequired"],
  setup(e, { emit: t }) {
    const { t: n } = De(), o = t, s = fe(!1), r = () => {
      s.value = !1, o("onLogoutRequired");
    };
    return (a, i) => (G(), X("div", Jd, [
      f("button", {
        onClick: i[0] || (i[0] = (c) => s.value = !0),
        class: "flex items-center justify-between w-full p-4 bg-red-50 text-red-600 rounded-2xl hover:bg-red-100 transition-colors group",
        "aria-label": k(n)("security.deleteAccountTitle")
      }, [
        f("div", Qd, [
          i[3] || (i[3] = f("span", { class: "text-xl group-hover:scale-110 transition-transform" }, "🗑️", -1)),
          f("div", ef, [
            f("p", tf, O(k(n)("security.deleteAccountTitle")), 1),
            f("p", nf, O(k(n)("security.deleteAccountSummary")), 1)
          ])
        ]),
        i[4] || (i[4] = f("span", { class: "text-gray-400 group-hover:translate-x-1 transition-transform" }, "❯", -1))
      ], 8, Zd),
      (G(), Qr(ea, { to: "body" }, [
        s.value ? (G(), X("div", {
          key: 0,
          class: "fixed inset-0 z-100 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm",
          onClick: i[2] || (i[2] = Es((c) => s.value = !1, ["self"]))
        }, [
          f("div", of, [
            wt(zd, {
              userSecurityApi: e.userSecurityApi,
              onCancel: i[1] || (i[1] = (c) => s.value = !1),
              onLogout: r
            }, null, 8, ["userSecurityApi"])
          ])
        ])) : Be("", !0)
      ]))
    ]));
  }
}), sf = { class: "w-full px-4 py-6 sm:py-10 bg-gray-50" }, rf = { class: "max-w-[min(100%,448px)] mx-auto p-6 bg-white rounded-2xl shadow-xl border border-gray-100" }, af = { class: "mb-8" }, lf = { class: "text-2xl font-black text-gray-700" }, cf = { class: "text-gray-500 mt-2 text-sm leading-relaxed" }, uf = { class: "space-y-6" }, df = { class: "block text-sm font-bold text-blue-700 mb-2" }, ff = { class: "p-4 rounded-xl border border-blue-50 bg-blue-50/30 text-gray-700 text-sm leading-relaxed" }, mf = { class: "block text-sm font-bold text-gray-700 mb-2" }, pf = { class: "p-4 rounded-xl border border-gray-100 bg-gray-50 text-gray-700 text-sm" }, wf = { class: "mb-2" }, hf = { class: "mt-3 text-xs text-gray-400 italic" }, gf = { class: "p-4 bg-red-50 text-red-700 rounded-lg border border-red-100 text-xs leading-relaxed" }, bf = { class: "font-black" }, _f = /* @__PURE__ */ Ne({
  __name: "DataDeletionPage",
  setup(e) {
    const { t } = De();
    return (n, o) => {
      const s = no("router-link");
      return G(), X("div", sf, [
        f("div", rf, [
          f("header", af, [
            f("h2", lf, O(k(t)("deletionPage.title")), 1),
            f("p", cf, O(k(t)("deletionPage.description")), 1)
          ]),
          f("div", uf, [
            f("section", null, [
              f("label", df, O(k(t)("deletionPage.method1Title")), 1),
              f("div", ff, O(k(t)("deletionPage.method1Desc")), 1)
            ]),
            f("section", null, [
              f("label", mf, O(k(t)("deletionPage.method2Title")), 1),
              f("div", pf, [
                f("p", wf, O(k(t)("deletionPage.method2Desc")), 1),
                o[0] || (o[0] = f("a", {
                  href: "mailto:bloomingrice12@gmail.com",
                  class: "text-blue-700 font-bold underline decoration-2 underline-offset-4"
                }, " bloomingrice12@gmail.com ", -1)),
                f("p", hf, O(k(t)("deletionPage.emailSubject")), 1)
              ])
            ]),
            f("div", gf, [
              f("span", bf, "⚠️ " + O(k(t)("common.important") || "Important") + ":", 1),
              Fe(" " + O(k(t)("deletionPage.footerNote")), 1)
            ]),
            wt(s, {
              to: "/",
              class: "block w-full py-4 rounded-xl font-bold text-center transition-all bg-gray-800 text-white active:scale-[0.98] shadow-lg shadow-gray-200"
            }, {
              default: Jt(() => [
                Fe(O(k(t)("common.backToHome") || "Back to Home"), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]);
    };
  }
}), um = /* @__PURE__ */ xo(_f, [["__scopeId", "data-v-7c3f9261"]]), yf = { class: "w-full px-4 py-6 sm:py-10 bg-gray-50" }, vf = { class: "max-w-[min(100%,480px)] mx-auto p-8 bg-white rounded-2xl shadow-xl border border-gray-100" }, Ef = { class: "mb-8 border-b border-gray-50 pb-6 text-center" }, kf = { class: "text-2xl font-black text-gray-800" }, Cf = { class: "mt-4 text-sm text-gray-600 leading-relaxed px-2" }, Lf = { class: "text-xs text-gray-400 mt-2 italic" }, Tf = { class: "space-y-8 text-sm leading-relaxed text-gray-600" }, Nf = { class: "font-bold text-gray-800 text-base mb-2" }, Af = { class: "bg-gray-50 p-4 rounded-xl border border-gray-100" }, xf = { class: "pt-6" }, If = { class: "mt-10 text-center" }, dm = /* @__PURE__ */ Ne({
  __name: "PrivacyPolicyPage",
  setup(e) {
    const { t } = De();
    return (n, o) => {
      const s = no("router-link");
      return G(), X("div", yf, [
        f("div", vf, [
          f("header", Ef, [
            f("h1", kf, O(k(t)("privacy.title")), 1),
            f("p", Cf, O(k(t)("privacy.intro")), 1),
            f("p", Lf, O(k(t)("privacy.updateDate")), 1)
          ]),
          f("div", Tf, [
            (G(), X(nt, null, Ot([1, 2, 3], (r) => f("section", { key: r }, [
              f("h2", Nf, O(k(t)(`privacy.section${r}Title`)), 1),
              f("p", Af, O(k(t)(`privacy.section${r}Content`)), 1)
            ])), 64)),
            f("div", xf, [
              wt(s, {
                to: "/account-delete",
                class: "block p-4 rounded-xl border border-blue-100 bg-blue-50 text-blue-700 text-center font-bold hover:bg-blue-100 transition-colors"
              }, {
                default: Jt(() => [
                  Fe(O(k(t)("deletionPage.title")) + " → ", 1)
                ]),
                _: 1
              })
            ])
          ]),
          f("footer", If, [
            wt(s, {
              to: "/",
              class: "text-gray-400 text-xs hover:text-gray-600 transition-colors"
            }, {
              default: Jt(() => [
                Fe(O(k(t)("common.backToHome")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]);
    };
  }
}), Of = { class: "w-full px-4 py-6 sm:py-10 bg-gray-50 text-left" }, Pf = { class: "max-w-[min(100%,600px)] mx-auto p-6 sm:p-10 bg-white rounded-2xl shadow-xl border border-gray-100" }, Sf = { class: "mb-8 border-b border-gray-100 pb-6 text-center" }, Df = { class: "text-2xl font-black text-gray-800" }, Mf = { class: "text-xs text-gray-400 mt-2 italic" }, $f = { class: "space-y-8 text-sm leading-relaxed text-gray-600" }, Rf = { class: "font-bold text-gray-800 text-base mb-2 flex items-center" }, Ff = { class: "bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2" }, Uf = { class: "font-bold text-blue-700" }, Bf = { class: "font-bold text-gray-800 text-base mb-2 flex items-center" }, Vf = { class: "bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2" }, Hf = { class: "font-medium text-red-600" }, Wf = { class: "font-bold text-gray-800 text-base mb-2 flex items-center" }, jf = { class: "bg-gray-50 p-4 rounded-xl border border-gray-100 space-y-2" }, Kf = { class: "font-bold underline text-gray-800" }, Yf = { class: "font-bold text-gray-800 text-base mb-2 flex items-center" }, Gf = { class: "bg-gray-50 p-4 rounded-xl border border-gray-100" }, qf = { class: "mt-10 text-center" }, fm = /* @__PURE__ */ Ne({
  __name: "TermsOfService",
  setup(e) {
    const { t } = De();
    return (n, o) => {
      const s = no("router-link");
      return G(), X("div", Of, [
        f("div", Pf, [
          f("header", Sf, [
            f("h1", Df, O(k(t)("terms.title")), 1),
            f("p", Mf, O(k(t)("terms.updateDate")) + "：2026-01-15", 1)
          ]),
          f("div", $f, [
            f("section", null, [
              f("h2", Rf, [
                o[0] || (o[0] = f("span", { class: "bg-blue-700 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs mr-2 shrink-0" }, "1", -1)),
                Fe(" " + O(k(t)("terms.section1.title")), 1)
              ]),
              f("div", Ff, [
                f("p", null, O(k(t)("terms.section1.p1")), 1),
                f("p", Uf, O(k(t)("terms.section1.p2")), 1),
                f("p", null, O(k(t)("terms.section1.p3")), 1)
              ])
            ]),
            f("section", null, [
              f("h2", Bf, [
                o[1] || (o[1] = f("span", { class: "bg-blue-700 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs mr-2 shrink-0" }, "2", -1)),
                Fe(" " + O(k(t)("terms.section2.title")), 1)
              ]),
              f("div", Vf, [
                f("p", null, O(k(t)("terms.section2.p1")), 1),
                f("p", Hf, O(k(t)("terms.section2.p2")), 1),
                f("p", null, O(k(t)("terms.section2.p3")), 1),
                f("p", null, O(k(t)("terms.section2.p4")), 1)
              ])
            ]),
            f("section", null, [
              f("h2", Wf, [
                o[2] || (o[2] = f("span", { class: "bg-blue-700 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs mr-2 shrink-0" }, "3", -1)),
                Fe(" " + O(k(t)("terms.section3.title")), 1)
              ]),
              f("div", jf, [
                f("p", null, O(k(t)("terms.section3.p1")), 1),
                f("p", Kf, O(k(t)("terms.section3.p2")), 1)
              ])
            ]),
            f("section", null, [
              f("h2", Yf, [
                o[3] || (o[3] = f("span", { class: "bg-blue-700 text-white w-5 h-5 rounded-full flex items-center justify-center text-xs mr-2 shrink-0" }, "4", -1)),
                Fe(" " + O(k(t)("terms.section4.title")), 1)
              ]),
              f("p", Gf, O(k(t)("terms.section4.p1")), 1)
            ])
          ]),
          f("footer", qf, [
            wt(s, {
              to: "/",
              class: "text-gray-400 text-xs hover:text-gray-600 transition-colors"
            }, {
              default: Jt(() => [
                Fe(O(k(t)("common.backToHome")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]);
    };
  }
});
function Xf(e) {
  const t = fe(!1), n = fe(null), o = fe(!1);
  return {
    loading: t,
    error: n,
    success: o,
    updateKeys: async (r) => {
      t.value = !0, n.value = null, o.value = !1;
      try {
        const a = await e.saveMerchantKeys(r);
        o.value = a.success;
      } catch (a) {
        throw n.value = (a == null ? void 0 : a.message) || "更新金鑰失敗，請稍後再試", o.value = !1, a;
      } finally {
        t.value = !1;
      }
    }
  };
}
const zf = { class: "merchant-keys-container" }, Jf = { class: "form-group" }, Zf = { class: "form-group" }, Qf = { class: "form-group" }, em = { class: "form-group" }, tm = { class: "form-group" }, nm = {
  key: 0,
  class: "message error-message"
}, om = {
  key: 1,
  class: "message success-message"
}, sm = ["disabled"], rm = /* @__PURE__ */ Ne({
  __name: "MerchantKeysPage",
  props: {
    merchantKeysApi: {}
  },
  setup(e) {
    const t = e, n = vs({
      ecpayMerchantID: "",
      payHashKey: "",
      payHashIV: "",
      invoiceHashKey: "",
      invoiceHashIV: ""
    }), { loading: o, error: s, success: r, updateKeys: a } = Xf(t.merchantKeysApi), i = async () => {
      try {
        await a({ ...n });
      } catch (c) {
        console.error("Submit failed:", c);
      }
    };
    return (c, d) => (G(), X("div", zf, [
      d[12] || (d[12] = f("h2", null, "配置/更新特店金鑰 (綠界 Helper)", -1)),
      d[13] || (d[13] = f("hr", null, null, -1)),
      f("form", {
        onSubmit: Es(i, ["prevent"]),
        class: "keys-form"
      }, [
        f("div", Jf, [
          d[5] || (d[5] = f("label", { for: "ecpayMerchantID" }, "綠界特店編號 (MerchantID)", -1)),
          Ke(f("input", {
            id: "ecpayMerchantID",
            "onUpdate:modelValue": d[0] || (d[0] = (_) => n.ecpayMerchantID = _),
            type: "text",
            placeholder: "例如: 12345678",
            required: ""
          }, null, 512), [
            [ut, n.ecpayMerchantID]
          ])
        ]),
        f("fieldset", null, [
          d[8] || (d[8] = f("legend", null, "付款金鑰 (Pay Keys)", -1)),
          f("div", Zf, [
            d[6] || (d[6] = f("label", { for: "payHashKey" }, "HashKey", -1)),
            Ke(f("input", {
              id: "payHashKey",
              "onUpdate:modelValue": d[1] || (d[1] = (_) => n.payHashKey = _),
              type: "text",
              required: ""
            }, null, 512), [
              [ut, n.payHashKey]
            ])
          ]),
          f("div", Qf, [
            d[7] || (d[7] = f("label", { for: "payHashIV" }, "HashIV", -1)),
            Ke(f("input", {
              id: "payHashIV",
              "onUpdate:modelValue": d[2] || (d[2] = (_) => n.payHashIV = _),
              type: "text",
              required: ""
            }, null, 512), [
              [ut, n.payHashIV]
            ])
          ])
        ]),
        f("fieldset", null, [
          d[11] || (d[11] = f("legend", null, "電子發票金鑰 (Invoice Keys)", -1)),
          f("div", em, [
            d[9] || (d[9] = f("label", { for: "invoiceHashKey" }, "HashKey", -1)),
            Ke(f("input", {
              id: "invoiceHashKey",
              "onUpdate:modelValue": d[3] || (d[3] = (_) => n.invoiceHashKey = _),
              type: "text",
              required: ""
            }, null, 512), [
              [ut, n.invoiceHashKey]
            ])
          ]),
          f("div", tm, [
            d[10] || (d[10] = f("label", { for: "invoiceHashIV" }, "HashIV", -1)),
            Ke(f("input", {
              id: "invoiceHashIV",
              "onUpdate:modelValue": d[4] || (d[4] = (_) => n.invoiceHashIV = _),
              type: "text",
              required: ""
            }, null, 512), [
              [ut, n.invoiceHashIV]
            ])
          ])
        ]),
        k(s) ? (G(), X("div", nm, O(k(s)), 1)) : Be("", !0),
        k(r) ? (G(), X("div", om, "金鑰配置更新成功！")) : Be("", !0),
        f("button", {
          type: "submit",
          disabled: k(o)
        }, O(k(o) ? "正在儲存..." : "儲存配置 (Upsert)"), 9, sm)
      ], 32)
    ]));
  }
}), mm = /* @__PURE__ */ xo(rm, [["__scopeId", "data-v-18e0cb3c"]]);
export {
  im as ChangePasswordPage,
  um as DataDeletionPage,
  mm as MerchantKeysPage,
  lm as MerchantUserPage,
  dm as PrivacyPolicyPage,
  fm as TermsOfService,
  cm as UserSecurityPanel
};
